
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("egCae", function(module, exports) {

$parcel$export(module.exports, "LivePageContent", () => $5c4227c64307072b$export$e68ce9fa06c56337);
$parcel$export(module.exports, "LivePageComponent", () => $5c4227c64307072b$export$d595fe40745c0112);

var $gwFzn = parcelRequire("gwFzn");

var $aTqya = parcelRequire("aTqya");

var $inPa6 = parcelRequire("inPa6");

var $9hlns = parcelRequire("9hlns");

var $6f0Oj = parcelRequire("6f0Oj");
var $ecnYn = parcelRequire("ecnYn");

var $3GP6F = parcelRequire("3GP6F");

var $dIouf = parcelRequire("dIouf");

var $irVI7 = parcelRequire("irVI7");
var $ln0hx = parcelRequire("ln0hx");
var $1eaCJ = parcelRequire("1eaCJ");
var $1kHsc = parcelRequire("1kHsc");
var $3XjWl = parcelRequire("3XjWl");

var $dHX7l = parcelRequire("dHX7l");
var $6gETM = parcelRequire("6gETM");

var $jXpbL = parcelRequire("jXpbL");

var $fyPYm = parcelRequire("fyPYm");

var $efvKr = parcelRequire("efvKr");

var $gTyTP = parcelRequire("gTyTP");

var $duVw1 = parcelRequire("duVw1");

var $9wGTI = parcelRequire("9wGTI");

var $4r9Ir = parcelRequire("4r9Ir");
var $7IghX = parcelRequire("7IghX");

var $fQa5o = parcelRequire("fQa5o");

var $dPJCf = parcelRequire("dPJCf");

var $yzRhM = parcelRequire("yzRhM");

var $5aayZ = parcelRequire("5aayZ");

var $l183O = parcelRequire("l183O");

var $aUp3o = parcelRequire("aUp3o");

var $cfxXX = parcelRequire("cfxXX");

var $cnsMc = parcelRequire("cnsMc");

var $3qFZr = parcelRequire("3qFZr");
const $5c4227c64307072b$var$spinnerContainerStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100vh'
});
// Handle aborting experiences
/* Why we're aborting each experience:
 * VIEW_PAGE_EXPERIENCE: Aborted due to not wanting live pages to affect core experience
 * VIEW_PAGE_SESSION_EXPERIENCE: Aborted due to not wanting live pages to affect classic view-page-specific experience. Live pages have their own live-page-session experience.
 * CREATE_PAGE_EXPERIENCE: Aborted due to not wanting live pages to affect core experience
 * VIEW_PAGE_EDIT_BUTTON_EXPERIENCE: Aborted due to editable live page starting but never finishing view-page/edit, because in ViewPageCommon, stickyHeader briefly mounts while loading `globalLiveState.isLive` and `editPermission`, which we unmount after we determine doc is an editable live page
 * VIEW_CONTENT_EXPERIENCE: Aborted due to live pages not integrating PerformanceMetrics.tsx, which is used to resolve this experience in normal pages.
 * Core experiences are not aborted if `live_page_exp_to_core_exp_migration` feature gate is enabled.
 */ const $5c4227c64307072b$var$useAbortNonLiveExperiences = (isLivePageExpToCoreExpMigrationEnabled)=>{
    const experienceTracker = (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).useContext((0, $1kHsc.ExperienceTrackerContext));
    const { hasStopped: hasViewPageExperienceStopped } = (0, $3XjWl.useExperienceState)((0, $irVI7.VIEW_PAGE_EXPERIENCE)) || {};
    const { hasStopped: hasViewPageSessionExperienceStopped } = (0, $3XjWl.useExperienceState)((0, $irVI7.VIEW_PAGE_SESSION_EXPERIENCE)) || {};
    const { hasStopped: hasCreatePageExperienceStopped } = (0, $3XjWl.useExperienceState)((0, $irVI7.CREATE_PAGE_EXPERIENCE)) || {};
    const { hasStopped: hasViewPageEditButtonExperienceStopped } = (0, $3XjWl.useExperienceState)((0, $irVI7.VIEW_PAGE_EDIT_BUTTON_EXPERIENCE)) || {};
    const { hasStopped: hasViewContentExperienceStopped } = (0, $3XjWl.useExperienceState)((0, $irVI7.VIEW_CONTENT_EXPERIENCE)) || {};
    const coreExperiencesToAbort = [
        {
            name: (0, $irVI7.VIEW_PAGE_EXPERIENCE),
            hasStopped: hasViewPageExperienceStopped
        },
        {
            name: (0, $irVI7.VIEW_CONTENT_EXPERIENCE),
            hasStopped: hasViewContentExperienceStopped
        },
        {
            name: (0, $irVI7.CREATE_PAGE_EXPERIENCE),
            hasStopped: hasCreatePageExperienceStopped
        }
    ];
    const nonCoreExperiencesToAbort = [
        {
            name: (0, $irVI7.VIEW_PAGE_SESSION_EXPERIENCE),
            hasStopped: hasViewPageSessionExperienceStopped
        },
        {
            name: (0, $irVI7.VIEW_PAGE_EDIT_BUTTON_EXPERIENCE),
            hasStopped: hasViewPageEditButtonExperienceStopped
        }
    ];
    const experiencesToAbort = isLivePageExpToCoreExpMigrationEnabled ? nonCoreExperiencesToAbort : coreExperiencesToAbort.concat(nonCoreExperiencesToAbort);
    experiencesToAbort.forEach((abortedExperience)=>{
        if (!abortedExperience.hasStopped) experienceTracker.abort({
            name: abortedExperience.name,
            reason: 'Live Page Editor was opened'
        });
    });
};
const $5c4227c64307072b$export$e68ce9fa06c56337 = ({ contentId: contentId, spaceKey: spaceKey, canEdit: canEdit, refetch: refetch, ClassicEditorContextProviderLoader: ClassicEditorContextProviderLoader, onNativeCollabLoad: onNativeCollabLoad, customPerfData: customPerfData, onDraftSyncSuccess: onDraftSyncSuccess, loadingPriority: loadingPriority })=>{
    const { livePageReleasePhase: livePageReleasePhase } = (0, $gTyTP.useIsLivePagesFeatureEnabled)();
    $5c4227c64307072b$var$useAbortNonLiveExperiences((0, $9wGTI.fg)('live_page_exp_to_core_exp_migration'));
    const LivePageWrapper = ClassicEditorContextProviderLoader ?? (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(LivePageWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $3qFZr.StartLivePageLoad), {
        contentId: contentId,
        viewMode: !canEdit
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $fyPYm.ContentViewedEvent), {
        contentId: contentId
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $aUp3o.LivePagesChangeboardingManager), {
        origin: "live-page"
    }), !(0, $9wGTI.fg)('live_page_exp_to_core_exp_migration') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ln0hx.ExperienceStart), {
        name: (0, $irVI7.LIVE_PAGE_VIEW_EXPERIENCE)
    }) : null, (0, $9wGTI.fg)('live_page_exp_to_core_exp_migration') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1eaCJ.ExperienceSuccess), {
        name: (0, $irVI7.CREATE_PAGE_EXPERIENCE),
        attributes: {
            isLivePage: true,
            livePageReleasePhase: livePageReleasePhase
        }
    }) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $cfxXX.LivePageSessionExperienceStart), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $jXpbL.NativeCollabLoader), {
        contentId: contentId,
        spaceKey: spaceKey,
        contentType: "page",
        key: contentId,
        onPermissionChange: refetch,
        canEdit: canEdit
    }, (propsFromNativeCollab)=>{
        const { viewMode: viewMode } = propsFromNativeCollab;
        const livePageCustomPerfData = {
            ...customPerfData,
            viewMode: viewMode
        };
        // TODO MODES-3871 Remove this triggerViewedAnalytics side effect when we cleanup LivePageComponent.
        // Trigger live page view analytics event once when the user views a live page.
        onNativeCollabLoad?.(contentId, viewMode);
        return(// This TreeRootForServerPlaceholderWrapper placed here to ensure the proper lookup of the placeholders for
        // SSRed loadables. Due to different component trees between server (LivePageComponent) and client (LivePageComponentServer)
        // the placeholder ids hierarchy is different. This wrapper terminates the lookup for placeholder ids on the common parent,
        // so it matches on both server and client.
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6gETM.TreeRootForServerPlaceholderWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dHX7l.FullPageEditorLoader), {
            ...propsFromNativeCollab,
            extensionContextProvider: {
                ClassicEditorContextProvider: ClassicEditorContextProviderLoader
            },
            hasEditPermission: canEdit,
            customPerfData: livePageCustomPerfData,
            onDraftSyncSuccess: onDraftSyncSuccess,
            loadingPriority: loadingPriority
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $cnsMc.LivePageShortcuts), {
            canEdit: canEdit
        })));
    }));
};
const $5c4227c64307072b$export$d595fe40745c0112 = ({ contentId: contentId, spaceKey: spaceKey, ClassicEditorContextProviderLoader: ClassicEditorContextProviderLoader, customPerfData: customPerfData, loadingPriority: loadingPriority })=>{
    const { canEdit: canEdit, loading: loading, contentQueryError: contentQueryError, refetch: refetch, networkStatus: networkStatus } = (0, $l183O.usePermissionCheck)(contentId);
    const prevCanEditRef = (0, $gwFzn.useRef)(undefined);
    const hasSentViewedAnalytics = (0, $gwFzn.useRef)(false);
    const { setMode: setMode } = (0, $efvKr.useLivePageStoreActions)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { isPreloading: isPreloading } = (0, $yzRhM.useEditorDataLoader)({
        contentId: contentId,
        spaceKey: spaceKey,
        canEdit: canEdit
    });
    const featureCodes = (0, $3GP6F.useFeatureCodesInURL)();
    (0, $gwFzn.useEffect)(()=>{
        hasSentViewedAnalytics.current = false;
        return ()=>{
            // Reset the mode when contentId changes or component unmounts
            setMode(undefined);
            prevCanEditRef.current = undefined;
        };
    }, [
        contentId,
        setMode
    ]);
    (0, $gwFzn.useEffect)(()=>{
        // Permissions on a page can change at anytime. Should update the mode if the new permissions are different from the previous ones.
        const hasPermissionsChanged = canEdit !== prevCanEditRef.current;
        if (hasPermissionsChanged) setMode(canEdit ? 'edit' : 'view');
        prevCanEditRef.current = canEdit;
    }, [
        canEdit,
        contentId,
        setMode
    ]);
    const { overrideUFORouteName: overrideUFORouteName } = (0, $dPJCf.useRouteActions)();
    (0, $gwFzn.useEffect)(()=>{
        overrideUFORouteName('live-edit');
    // Live doc transitions trigger a UFO route change but usually don't trigger a LivePageComponent remount, so we need to re-run on contentId change
    }, [
        overrideUFORouteName,
        contentId
    ]);
    const handleNativeCollabLoad = (contentId, viewMode)=>{
        if (hasSentViewedAnalytics.current === false) {
            (0, $5aayZ.triggerViewedAnalytics)({
                contentId: contentId,
                editPermission: canEdit,
                createAnalyticsEvent: createAnalyticsEvent,
                viewMode: viewMode,
                ...featureCodes && featureCodes.from ? {
                    from: featureCodes.from
                } : {}
            });
            hasSentViewedAnalytics.current = true;
        }
    };
    if (contentQueryError) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dIouf.ErrorDisplay), {
        error: contentQueryError
    });
    const skipLoadingScreenWhenSSRed = window.__SSR_RENDERED__;
    if (isPreloading && !skipLoadingScreenWhenSSRed || // don't unmount live pages editor on permission refetch
    loading && networkStatus !== (0, $aTqya.NetworkStatus).refetch) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        xcss: $5c4227c64307072b$var$spinnerContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $9hlns.default), {
        interactionName: "live-pages-loading-spinner",
        size: "medium"
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4r9Ir.NewCommentsProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $7IghX.PageCommentsCountProvider), {
        contentId: contentId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($5c4227c64307072b$export$e68ce9fa06c56337, {
        contentId: contentId,
        spaceKey: spaceKey,
        ClassicEditorContextProviderLoader: ClassicEditorContextProviderLoader,
        canEdit: canEdit,
        refetch: refetch,
        onNativeCollabLoad: handleNativeCollabLoad,
        customPerfData: customPerfData,
        loadingPriority: loadingPriority
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $fQa5o.OnboardingNthUserContentTypeSpotlight), {
        contentType: (0, $fQa5o.ContentType).LIVE_DOC,
        contentId: contentId
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $duVw1.LivePageInviteNudge), null)));
};

});
parcelRegister("3GP6F", function(module, exports) {

$parcel$export(module.exports, "useFeatureCodesInURL", () => $9bc3195b956679d5$export$eddc138581adbc11);

var $gwFzn = parcelRequire("gwFzn");

var $4y1GY = parcelRequire("4y1GY");

var $dPJCf = parcelRequire("dPJCf");

var $71GjD = parcelRequire("71GjD");
var $lpPVE = parcelRequire("lpPVE");

var $lpPVE = parcelRequire("lpPVE");
const $9bc3195b956679d5$export$eddc138581adbc11 = ()=>{
    const history = (0, $dPJCf.useHistory)();
    const location = (0, $4y1GY.useLocation)();
    const queryParams = location?.search;
    const queryParamsFeatureCodes = (0, $lpPVE.getFeatureCodes)(new URLSearchParams(queryParams));
    const [featureCodes, setFeatureCodes] = (0, $gwFzn.useState)(queryParamsFeatureCodes);
    (0, $gwFzn.useEffect)(()=>{
        if (queryParams && queryParams.includes((0, $71GjD.FEATURE_CODES_QUERY_PARAM))) {
            setFeatureCodes(queryParamsFeatureCodes);
            (0, $lpPVE.hideFeatureCodesQueryParam)(history, location);
        }
    }, [
        history,
        location,
        queryParams,
        queryParamsFeatureCodes
    ]);
    return featureCodes;
};

});
parcelRegister("71GjD", function(module, exports) {

$parcel$export(module.exports, "FeatureCode", () => $9d2fac30cbee1d6f$export$661babcb078ff919);
$parcel$export(module.exports, "FEATURE_CODES_QUERY_PARAM", () => $9d2fac30cbee1d6f$export$18fd2ee3b879d0cd);
/**
 * Feature attribution enum for tracking feature usage/attribution
 *
 * @note All feature codes are intended to be 8 characters or less in length
 *
 * @see https://hello.atlassian.net/wiki/x/lQxt9Q
 */ var $9d2fac30cbee1d6f$export$661babcb078ff919 = /*#__PURE__*/ function(FeatureCode) {
    /** Confluence Home Feeds (Following and Popular) **/ FeatureCode["HOME_FEED"] = "HOMEFEED";
    /** Confluence End of Page Recommendations (Related Pages) **/ FeatureCode["EOP_REC"] = "EOPREC";
    /** Confluence End of Page Recommendations (Related Pages) Hover Card **/ FeatureCode["EOP_REC_CARD"] = "EOPCARD";
    /** Confluence Page Tree **/ FeatureCode["PAGE_TREE"] = "PAGETREE";
    /** Confluence Page Tree Card **/ FeatureCode["PAGE_TREE_CARD"] = "TREECARD";
    /** Following Feed email **/ FeatureCode["FOLLOWING_FEED_EMAIL"] = "FLLWEML";
    /** Popular Feed email **/ FeatureCode["POPULAR_FEED_EMAIL"] = "PPLREML";
    FeatureCode["ADMIN_KEY_EMAIL"] = "ADMINEML";
    FeatureCode["ATTACHMENT_EMAILS"] = "ATTCHEML";
    FeatureCode["BATCH_EMAIL"] = "BATCHEML";
    FeatureCode["BLOG_CREATED_EMAIL"] = "BLOGEML";
    FeatureCode["BULK_ARCHIVE_EMAIL"] = "BLKAREML";
    FeatureCode["BULK_OWNER_CHANGE_EMAIL"] = "BLKOWEML";
    FeatureCode["CONFLUENCE_WRAPPED_EMAIL"] = "WRAPEML";
    FeatureCode["CONTACT_ADMINISTRATORS_EMAIL"] = "CTADMEML";
    FeatureCode["CONTENT_OWNER_CHANGE_EMAIL"] = "OWNREML";
    FeatureCode["CONTENT_REDACTION_EMAIL"] = "RDCTDEML";
    FeatureCode["EXCO_ADDED_TO_SPACE_EMAIL"] = "EXCASEML";
    FeatureCode["EXCO_REQUEST_ACCESS_EMAIL"] = "EXCRAEML";
    FeatureCode["EXCO_SPACE_READY_EMAIL"] = "EXCSREML";
    FeatureCode["IMPORTER_NOTIFICATIONS"] = "IMPRTNTF";
    FeatureCode["LIVE_PAGE_PUBLISHED_EMAIL"] = "LPPEML";
    FeatureCode["MENTIONS_EMAIL"] = "MNTNEML";
    FeatureCode["PAGE_CREATED_EMAIL"] = "PAGEEML";
    FeatureCode["REMINDER_EMAIL"] = "RMNDREML";
    FeatureCode["REQUEST_AND_GRANT_ACCESS_EMAILS"] = "REQACEML";
    FeatureCode["REQUEST_AND_GRANT_ACCESS_SLACK"] = "REQACSLK";
    FeatureCode["TASKS_EMAIL"] = "TASKEML";
    FeatureCode["TEAM_CALENDAR_EMAIL"] = "CLNDREML";
    FeatureCode["WHITEBOARD_CREATED_EMAIL"] = "WTBRDEML";
    FeatureCode["CONTENT_REDACTION_IN_APP"] = "RDCTDAPP";
    FeatureCode["DAILY_DIGEST_EMAIL"] = "DIGSTEML";
    FeatureCode["MENTIONS_REMINDER_EMAIL"] = "MNTNREML";
    FeatureCode["PUBLIC_LINK_EMAIL"] = "PBLNKEML";
    FeatureCode["REQUEST_AND_GRANT_ACCESS_IN_APP"] = "REQACAPP";
    FeatureCode["SHARE_AND_RESTRICT_DIALOG"] = "SRDIALOG";
    return FeatureCode;
}({});
const $9d2fac30cbee1d6f$export$18fd2ee3b879d0cd = 'atl_f';
const $9d2fac30cbee1d6f$export$384cf7f2010cb469 = 'confluence_frontend_insights_feature_attribution';

});

parcelRegister("lpPVE", function(module, exports) {

$parcel$export(module.exports, "generatePathWithFeatureCodesQueryParam", () => $d9de10c6417158bd$export$d347e131abf45bea);
$parcel$export(module.exports, "getFeatureCodes", () => $d9de10c6417158bd$export$3c2127388df02347);
$parcel$export(module.exports, "hideFeatureCodesQueryParam", () => $d9de10c6417158bd$export$241f453208292937);

var $9wGTI = parcelRequire("9wGTI");

var $71GjD = parcelRequire("71GjD");
const $d9de10c6417158bd$export$d347e131abf45bea = (href, featureCodes)=>{
    if (!featureCodes.length) return href;
    const [path, queryString] = href.split('?');
    const searchParams = new URLSearchParams(queryString);
    // If the query param already exists, append the new feature codes to the existing ones
    if (searchParams.has((0, $71GjD.FEATURE_CODES_QUERY_PARAM))) {
        const existingFeatureCodes = searchParams.get((0, $71GjD.FEATURE_CODES_QUERY_PARAM)) || '';
        const newFeatureCodes = [
            ...new Set([
                ...existingFeatureCodes.split(','),
                ...featureCodes
            ])
        ];
        searchParams.set((0, $71GjD.FEATURE_CODES_QUERY_PARAM), newFeatureCodes.join(','));
    } else searchParams.append((0, $71GjD.FEATURE_CODES_QUERY_PARAM), featureCodes.join(','));
    const newQueryString = searchParams.toString();
    return newQueryString ? `${path}?${newQueryString}` : path;
};
const $d9de10c6417158bd$export$3c2127388df02347 = (queryParams)=>{
    if (!(0, $9wGTI.fg)('confluence_frontend_insights_feature_attribution')) return {
        from: undefined
    };
    const featureCodes = queryParams.get((0, $71GjD.FEATURE_CODES_QUERY_PARAM))?.split(',');
    const fromCode = featureCodes?.find((code)=>Object.values((0, $71GjD.FeatureCode)).includes(code));
    return {
        from: fromCode
    };
};
const $d9de10c6417158bd$export$241f453208292937 = (history, location)=>{
    if (!location?.search?.includes((0, $71GjD.FEATURE_CODES_QUERY_PARAM))) return;
    const searchParams = new URLSearchParams(location.search);
    searchParams.delete((0, $71GjD.FEATURE_CODES_QUERY_PARAM));
    const search = searchParams.toString();
    history?.replace?.({
        ...location,
        search: search ? `?${search}` : ''
    });
};
const $d9de10c6417158bd$export$866aaa0a921ee13d = (existingFeatureCodes, featureCodeToCheck)=>{
    return existingFeatureCodes.includes(featureCodeToCheck);
};
const $d9de10c6417158bd$export$84f5742c2ddda28f = (existingFeatureCodes, featureCodeToAdd)=>{
    if ($d9de10c6417158bd$export$866aaa0a921ee13d(existingFeatureCodes, featureCodeToAdd)) return existingFeatureCodes;
    return [
        ...existingFeatureCodes,
        featureCodeToAdd
    ];
};
const $d9de10c6417158bd$export$f2b1b8a892016485 = (existingFeatureCodes, featureCodeToRemove)=>{
    if (!$d9de10c6417158bd$export$866aaa0a921ee13d(existingFeatureCodes, featureCodeToRemove)) return existingFeatureCodes;
    return existingFeatureCodes.filter((code)=>code !== featureCodeToRemove);
};

});


parcelRegister("ln0hx", function(module, exports) {

$parcel$export(module.exports, "ExperienceStart", () => $0c8ceb2bfbb43f95$export$f20b867e738a222c);

var $gwFzn = parcelRequire("gwFzn");

var $1kHsc = parcelRequire("1kHsc");
function $0c8ceb2bfbb43f95$export$f20b867e738a222c({ id: id, name: name, attributes: attributes, collect: collect, onSuccess: onSuccess }) {
    const experienceTracker = (0, $gwFzn.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const wasCalledRef = (0, $gwFzn.useRef)(false);
    if (!wasCalledRef.current) {
        experienceTracker.start({
            attributes: attributes,
            name: name,
            id: id,
            collect: collect,
            onSuccess: onSuccess
        });
        wasCalledRef.current = true;
    }
    return null;
}

});

parcelRegister("1eaCJ", function(module, exports) {

$parcel$export(module.exports, "ExperienceSuccess", () => $03574d8c2683228e$export$4962f3898bd5c829);

var $gwFzn = parcelRequire("gwFzn");

var $1kHsc = parcelRequire("1kHsc");
function $03574d8c2683228e$export$4962f3898bd5c829({ name: name, attributes: attributes }) {
    const experienceTracker = (0, $gwFzn.useContext)((0, $1kHsc.ExperienceTrackerContext));
    (0, $gwFzn.useEffect)(()=>experienceTracker.succeed({
            name: name,
            attributes: attributes
        }), [
        name,
        attributes,
        experienceTracker
    ]);
    return null;
}

});

parcelRegister("3XjWl", function(module, exports) {

$parcel$export(module.exports, "useExperienceState", () => $a5d6810b007644fc$export$4a4fb33de7d01f75);

var $gwFzn = parcelRequire("gwFzn");

var $1kHsc = parcelRequire("1kHsc");
const $a5d6810b007644fc$export$4a4fb33de7d01f75 = (experienceName)=>{
    const experienceTracker = (0, $gwFzn.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const [experienceState, setExperienceState] = (0, $gwFzn.useState)(experienceTracker.getExperienceState(experienceName));
    (0, $gwFzn.useEffect)(()=>experienceTracker.subscribe((e)=>{
            if (e.name === experienceName) setExperienceState(experienceTracker.getExperienceState(experienceName));
        }), [
        experienceName,
        experienceTracker
    ]);
    return experienceState;
};

});

parcelRegister("dHX7l", function(module, exports) {

$parcel$export(module.exports, "FullPageEditorLoader", () => $4f86ad448fd6abed$export$d49c8c8cf1b10f7e);
$parcel$export(module.exports, "useEditorFullPageExperiments", () => (parcelRequire("eLnQS")).useEditorFullPageExperiments);
$parcel$export(module.exports, "TreeRootForServerPlaceholderWrapper", () => (parcelRequire("6gETM")).TreeRootForServerPlaceholderWrapper);

var $jmjWc = parcelRequire("jmjWc");

var $eLnQS = parcelRequire("eLnQS");

var $6gETM = parcelRequire("6gETM");

const $4f86ad448fd6abed$export$d49c8c8cf1b10f7e = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "cXxVt",
    name: "FullPageEditorLoader",
    loader: async ()=>{
        const { FullPageEditorComponent: FullPageEditorComponent } = await (parcelRequire("kNcYY"));
        return FullPageEditorComponent;
    }
});

});
parcelRegister("eLnQS", function(module, exports) {

$parcel$export(module.exports, "useEditorFullPageExperiments", () => $5e22f724447894e7$export$367f35882b7b4a5b);

var $gwFzn = parcelRequire("gwFzn");

var $6mKj3 = parcelRequire("6mKj3");
const $5e22f724447894e7$export$367f35882b7b4a5b = ()=>{
    // IMPORTANT: If you add a new feature flag here, please make sure to add it to the
    // `featureFlagsPluginOptions` function in 'packages/editor/editor-presets-confluence/src/presets/full-page/pluginOptions/featureFlagsPluginOptions.ts`.
    return (0, $gwFzn.useMemo)(()=>({
            'table-drag-and-drop': (0, $6mKj3.expVal)('platform_editor_tables_drag_and_drop', 'isEnabled', false),
            'table-selector': (0, $6mKj3.expVal)('platform_editor_tables_table_selector', 'isEnabled', false),
            'macro-interaction-updates': true,
            'table-with-fixed-column-widths-option': true,
            'more-elements-in-quick-insert-view': true
        }), []);
};

});

parcelRegister("6gETM", function(module, exports) {

$parcel$export(module.exports, "TreeRootForServerPlaceholderWrapper", () => $5ed14ae7f856df1d$export$4279728e9b12d235);

var $gwFzn = parcelRequire("gwFzn");

var $jmjWc = parcelRequire("jmjWc");
const $5ed14ae7f856df1d$export$204c1449657d49fd = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, children);
const $5ed14ae7f856df1d$export$ae764d691d5f37c6 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "3loHF",
    name: "TreeRootForServerPlaceholder",
    loader: async ()=>$5ed14ae7f856df1d$export$204c1449657d49fd,
    _reactTreeRootForServerPlaceholderId: true
});
const $5ed14ae7f856df1d$export$4279728e9b12d235 = ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($5ed14ae7f856df1d$export$ae764d691d5f37c6, null, children);
};

});

parcelRegister("kNcYY", function(module, exports) {

let $f232744801886ee1$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $f232744801886ee1$var$load("dH2J7"),
    $f232744801886ee1$var$load("cCQ7p"),
    $f232744801886ee1$var$load("jUhND"),
    $f232744801886ee1$var$load("2TjAk"),
    $f232744801886ee1$var$load("i2KvU"),
    $f232744801886ee1$var$load("5bVye"),
    $f232744801886ee1$var$load("g3FCv"),
    $f232744801886ee1$var$load("9ECxk"),
    $f232744801886ee1$var$load("lPCqB"),
    $f232744801886ee1$var$load("emd3r"),
    $f232744801886ee1$var$load("3i0mi"),
    $f232744801886ee1$var$load("7YFVd"),
    $f232744801886ee1$var$load("1c4TZ"),
    $f232744801886ee1$var$load("cplyI"),
    $f232744801886ee1$var$load("5HsIb"),
    $f232744801886ee1$var$load("7VwsU"),
    $f232744801886ee1$var$load("fsZ6i"),
    $f232744801886ee1$var$load("7KMgV"),
    $f232744801886ee1$var$load("3689E"),
    $f232744801886ee1$var$load("g1XVY"),
    $f232744801886ee1$var$load("keSaw"),
    $f232744801886ee1$var$load("5SiDe"),
    $f232744801886ee1$var$load("lyxzP"),
    $f232744801886ee1$var$load("lU1wr"),
    $f232744801886ee1$var$load("29wqP"),
    $f232744801886ee1$var$load("dlP32"),
    $f232744801886ee1$var$load("kpINU"),
    $f232744801886ee1$var$load("6DO1j"),
    $f232744801886ee1$var$load("8wMGm"),
    $f232744801886ee1$var$load("bbnaa"),
    $f232744801886ee1$var$load("aZinD"),
    $f232744801886ee1$var$load("6qah4"),
    $f232744801886ee1$var$load("c6MKV"),
    $f232744801886ee1$var$load("i0gb6"),
    $f232744801886ee1$var$load("g7QTt"),
    $f232744801886ee1$var$load("iB2zz"),
    $f232744801886ee1$var$load("7x00I")
]).then(()=>parcelRequire('h1Y8a'));

});


parcelRegister("fyPYm", function(module, exports) {

$parcel$export(module.exports, "ContentViewedEvent", () => $701bdc3764047e40$export$cc2fc38458ee98cc);

var $gwFzn = parcelRequire("gwFzn");

var $j1Ss3 = parcelRequire("j1Ss3");

var $5SaYG = parcelRequire("5SaYG");
let $701bdc3764047e40$var$lastContentId;
const $701bdc3764047e40$export$cc2fc38458ee98cc = ({ contentId: contentId })=>{
    (0, $gwFzn.useEffect)(()=>{
        $701bdc3764047e40$var$lastContentId = contentId;
    }, [
        contentId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $j1Ss3.Query), {
        query: (0, $5SaYG.ContentViewedEventQuery),
        variables: {
            contentId: contentId
        },
        fetchPolicy: "network-only",
        skip: $701bdc3764047e40$var$lastContentId === contentId
    }, ()=>null);
};

});
parcelRegister("5SaYG", function(module, exports) {

$parcel$export(module.exports, "ContentViewedEventQuery", () => $c8189816457a0210$export$4dc4e51ac72e6b33);

var $d2LG0 = parcelRequire("d2LG0");
const $c8189816457a0210$export$4dc4e51ac72e6b33 = (0, $d2LG0.default)`query ContentViewedEventQuery($contentId:ID){content(id:$contentId trigger:"viewed"){nodes{id}}}`;

});


parcelRegister("duVw1", function(module, exports) {

$parcel$export(module.exports, "LivePageInviteNudge", () => $a77e53442da85dae$export$6b6138d01d6d1ac8);

var $gwFzn = parcelRequire("gwFzn");

var $24lt4 = parcelRequire("24lt4");

var $dIouf = parcelRequire("dIouf");

var $2eWz9 = parcelRequire("2eWz9");

var $gRoAW = parcelRequire("gRoAW");
const $a77e53442da85dae$var$LivePageInviteNudgeComponent = ()=>{
    const [{ hasLivePageChanges: hasLivePageChanges }] = (0, $gRoAW.useLivePageInviteNudgeStore)();
    const { isEligible: isEligible } = (0, $2eWz9.useLivePageInviteNudgeV2Eligible)();
    if (!isEligible || !hasLivePageChanges) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $24lt4.ContextualInviteNudgeFlagLoadable), {
        source: "live-page"
    });
};
const $a77e53442da85dae$export$6b6138d01d6d1ac8 = (0, $dIouf.withTransparentErrorBoundary)({
    attribution: (0, $dIouf.Attribution).FLYWHEEL_ADOPTION
})($a77e53442da85dae$var$LivePageInviteNudgeComponent);

});
parcelRegister("24lt4", function(module, exports) {

$parcel$export(module.exports, "ContextualInviteNudgeFlagLoadable", () => $cc44261a43a3a2c8$export$ec07ab86dd373035);

var $jmjWc = parcelRequire("jmjWc");

const $cc44261a43a3a2c8$export$ec07ab86dd373035 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "tc7qj",
    name: "ContextualInviteNudgeFlagLoadable",
    loader: async ()=>(await (parcelRequire("5QOW4"))).ContextualInviteNudgeFlag
});

});
parcelRegister("5QOW4", function(module, exports) {

let $442951d088c9192c$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $442951d088c9192c$var$load("VOOTa").then(()=>parcelRequire('8FWBg'));

});


parcelRegister("2eWz9", function(module, exports) {

$parcel$export(module.exports, "useLivePageInviteNudgeV2Eligible", () => $547ccbe6e9802517$export$f9b6262172e40aa3);

var $9wGTI = parcelRequire("9wGTI");
const $547ccbe6e9802517$export$f9b6262172e40aa3 = ()=>{
    return {
        isEligible: (0, $9wGTI.fg)('livepageinvitenudgev2')
    };
};

});

parcelRegister("gRoAW", function(module, exports) {

$parcel$export(module.exports, "useLivePageInviteNudgeStore", () => $ef32078ae52b55f6$export$e36304341bdc761e);

var $iFWZA = parcelRequire("iFWZA");
var $4ZoIm = parcelRequire("4ZoIm");
const $ef32078ae52b55f6$var$Store = (0, $4ZoIm.createStore)({
    initialState: {
        hasLivePageChanges: false
    },
    actions: {
        setHasLivePageChanges: (hasLivePageChanges)=>({ setState: setState })=>{
                setState({
                    hasLivePageChanges: hasLivePageChanges
                });
            }
    },
    name: 'live-page-invite-nudge-store'
});
const $ef32078ae52b55f6$export$e36304341bdc761e = (0, $iFWZA.createHook)($ef32078ae52b55f6$var$Store);
const $ef32078ae52b55f6$export$a7adfb4ecca412a3 = (0, $iFWZA.createActionsHook)($ef32078ae52b55f6$var$Store);

});


parcelRegister("yzRhM", function(module, exports) {

$parcel$export(module.exports, "useEditorDataLoader", () => $d2444e2b4c0303a2$export$2d5821aa0ae081e8);

var $gwFzn = parcelRequire("gwFzn");

var $fWGpT = parcelRequire("fWGpT");
var $5Za2S = parcelRequire("5Za2S");

var $2MhGC = parcelRequire("2MhGC");

var $jXpbL = parcelRequire("jXpbL");

var $bQm3c = parcelRequire("bQm3c");

var $9wGTI = parcelRequire("9wGTI");
const $d2444e2b4c0303a2$export$2d5821aa0ae081e8 = ({ contentId: contentId, spaceKey: spaceKey, canEdit: canEdit })=>{
    const { userId: userId, cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const { nativeEditorComponentsPreloader: nativeEditorComponentsPreloader } = (0, $2MhGC.useEditPageLoadingActions)();
    const { setCollabEditProvider: setCollabEditProvider, setHasInitialDraft: setHasInitialDraft } = (0, $jXpbL.useNativeCollabActions)();
    // presenceId is pulled from the native collab state to ensure that we have a consistent presenceId for a given contentId
    // across the collab providers that drive editor as well as presence components (telepointer and avatar colors).
    const [{ presenceId: presenceId }] = (0, $jXpbL.useNativeCollabPresenceState)();
    const presenceIdRef = (0, $gwFzn.useRef)(presenceId);
    presenceIdRef.current = presenceId;
    const [isPreloading, setIsPreloading] = (0, $gwFzn.useState)(true);
    const [errors, setErrors] = (0, $gwFzn.useState)([]);
    const latestPreloadingContentIdRef = (0, $gwFzn.useRef)(null);
    const getNCSCollabProvider = (0, $gwFzn.useCallback)((draft, contentType, activity)=>{
        try {
            const ncsProvider = (0, $fWGpT.getCollabEditProvider)({
                contentId: contentId,
                cloudId: cloudId,
                contentType: contentType,
                permissionTokenRefresh: (0, $jXpbL.fetchCollabPermissionToken)(contentId, undefined),
                initialDraft: draft,
                isLivePage: true,
                presenceId: presenceIdRef.current,
                presenceActivity: activity,
                userId: userId
            });
            setCollabEditProvider(ncsProvider);
            // @ts-ignore
            const hasInitialDraft = Boolean(ncsProvider?.initialDraft);
            setHasInitialDraft(hasInitialDraft);
        } catch (error) {
            setErrors((prevErrors)=>[
                    ...prevErrors,
                    error
                ]);
        }
    }, [
        cloudId,
        contentId,
        presenceIdRef,
        userId,
        setCollabEditProvider,
        setHasInitialDraft
    ]);
    // Preload should be called once per contentId
    (0, $gwFzn.useEffect)(()=>{
        const preload = async ()=>{
            try {
                const contentType = 'page';
                const activity = canEdit ? 'editor' : 'viewer';
                const getDraftPromise = (0, $5Za2S.getDraft)(contentId);
                const results = await Promise.all([
                    (0, $9wGTI.fg)('confluence_live_pages_unified_query') ? Promise.resolve() // does nothing, just keeps order of destructured results
                     : (0, $2MhGC.preloadEditorData)({
                        spaceKey: spaceKey,
                        contentId: contentId,
                        userId: userId,
                        useCache: true,
                        cloudId: cloudId,
                        isBlog: false,
                        isLivePage: true
                    }),
                    nativeEditorComponentsPreloader(),
                    getDraftPromise
                ]);
                const [, , draftResponse] = results;
                /**
				 * This if condition fixes issue where transitioning between different live docs too quickly cause NCS collab provider not connected
				 * The issue happens when user has already transitioned away from the page when the promise.all above finished
				 * To avoid the issue, only get a new NCS collab provider and finish preloading if the latest preloading content id matches the preloaded content Id
				 */ if (latestPreloadingContentIdRef.current === contentId || !(0, $9wGTI.fg)('confluence_frontend_live_edit_only_get_latest_ncs')) {
                    getNCSCollabProvider(draftResponse, contentType, activity);
                    setIsPreloading(false);
                    latestPreloadingContentIdRef.current = null;
                }
            } catch (error) {
                setErrors((prevErrors)=>[
                        ...prevErrors,
                        error
                    ]);
            }
        };
        latestPreloadingContentIdRef.current = contentId;
        preload().catch((error)=>{
            setErrors((prevErrors)=>[
                    ...prevErrors,
                    error
                ]);
        });
        return ()=>{
            setIsPreloading(true);
        };
    // The dependency array should not change per page edit
    // This prevents multiple preloads for the same contentId, which can cause NCS connection issues
    }, [
        canEdit,
        cloudId,
        contentId,
        spaceKey,
        getNCSCollabProvider,
        nativeEditorComponentsPreloader,
        userId,
        latestPreloadingContentIdRef
    ]);
    return {
        isPreloading: isPreloading,
        errors: errors
    };
};

});

parcelRegister("5aayZ", function(module, exports) {

$parcel$export(module.exports, "triggerViewedAnalytics", () => $38cd43e1ba367cd0$export$d215db265191397f);

var $hp2SH = parcelRequire("hp2SH");

var $5cKfR = parcelRequire("5cKfR");
const $38cd43e1ba367cd0$var$NO_DATE_DEFINED = -1;
const $38cd43e1ba367cd0$var$dayInMilliseconds = 86400000;
const $38cd43e1ba367cd0$var$calculateDaysSincePageCreated = (createdDate)=>{
    // -1 is used here when the date is null to match the route level analytics event in SendTrackViewPageEvent.js
    if (!createdDate) return $38cd43e1ba367cd0$var$NO_DATE_DEFINED;
    const timeDifference = new Date().getTime() - new Date(createdDate).getTime();
    return Math.round(timeDifference / $38cd43e1ba367cd0$var$dayInMilliseconds);
};
const $38cd43e1ba367cd0$var$fetchLivePageContentInfo = async (contentId)=>{
    try {
        const { data: data } = await (0, $hp2SH.getApolloClient)().query({
            query: (0, $5cKfR.LivePageContentQuery),
            context: {
                single: true
            },
            variables: {
                contentId: contentId
            }
        });
        return data;
    } catch (error) {
        // NOTE: Intentionally swallow any possible error here as this query is only used for analytics but we still want to track the event
        return undefined;
    }
};
const $38cd43e1ba367cd0$export$d215db265191397f = async ({ contentId: contentId, editPermission: editPermission, createAnalyticsEvent: createAnalyticsEvent, viewMode: viewMode, from: from })=>{
    const data = await $38cd43e1ba367cd0$var$fetchLivePageContentInfo(contentId);
    createAnalyticsEvent({
        type: 'sendTrackEvent',
        data: {
            source: 'viewPageScreen',
            actionSubject: 'page',
            action: 'viewed',
            objectType: 'page',
            containerType: 'space',
            containerId: data?.singleContent?.space?.id,
            objectId: contentId,
            attributes: {
                isLivePage: true,
                hasEditPermission: editPermission,
                daysSinceCreated: $38cd43e1ba367cd0$var$calculateDaysSincePageCreated(data?.singleContent?.history?.createdDate),
                viewMode: viewMode,
                from: from
            }
        }
    }).fire();
};

});
parcelRegister("5cKfR", function(module, exports) {

$parcel$export(module.exports, "LivePageContentQuery", () => $e7ec07b09c2ae716$export$37e9648e439f31ee);

var $d2LG0 = parcelRequire("d2LG0");
const $e7ec07b09c2ae716$export$37e9648e439f31ee = (0, $d2LG0.default)`query LivePageContentQuery($contentId:ID){singleContent(id:$contentId){id space{id}history{createdDate}}}`;

});


parcelRegister("l183O", function(module, exports) {

$parcel$export(module.exports, "usePermissionCheck", () => $9549f93bbdcdf0e1$export$cdd86cf5fc73d613);
/**
 * @graphql cc
 */ 
var $d2LG0 = parcelRequire("d2LG0");

var $xQxzY = parcelRequire("xQxzY");
const $9549f93bbdcdf0e1$export$cdd86cf5fc73d613 = (contentId)=>{
    const { data: data, loading: loading, error: error, refetch: refetch, networkStatus: networkStatus } = (0, $xQxzY.useQuery)((0, $d2LG0.default)`query usePermissionCheckPermissionCheckContentQuery($contentId:ID!){content(id:$contentId){nodes{id type operations{operation targetType}}}}`, {
        variables: {
            contentId: contentId
        },
        notifyOnNetworkStatusChange: true,
        fetchPolicy: 'cache-and-network'
    });
    const contentNode = data?.content?.nodes?.[0];
    const operations = contentNode?.operations ?? [];
    const contentType = contentNode?.type ?? undefined;
    const editPermission = operations.some((operationResults)=>operationResults?.operation === 'update' && operationResults?.targetType === contentType);
    return {
        canEdit: editPermission,
        loading: loading,
        contentQueryError: error,
        refetch: refetch,
        networkStatus: networkStatus
    };
};

});

parcelRegister("cfxXX", function(module, exports) {

$parcel$export(module.exports, "LivePageSessionExperienceStart", () => $04a7907e02801b8f$export$30ee8512ff42aa4);

var $gwFzn = parcelRequire("gwFzn");

var $ln0hx = parcelRequire("ln0hx");
var $amL1s = parcelRequire("amL1s");
var $irVI7 = parcelRequire("irVI7");

var $gTyTP = parcelRequire("gTyTP");
const $04a7907e02801b8f$var$livePageSessionCollect = (events, experience)=>{
    const livePageEditExperienceName = (0, $amL1s.getLivePageEditExperienceName)();
    const livePageViewExperienceName = (0, $amL1s.getLivePageViewExperienceName)();
    const liveEditExperienceFailed = events.find(({ action: action, name: name })=>action === 'taskFail' && name === livePageEditExperienceName);
    const liveEditExperienceAborted = events.find(({ action: action, name: name })=>action === 'taskAbort' && name === livePageEditExperienceName);
    const liveViewExperienceFailed = events.find(({ action: action, name: name })=>action === 'taskFail' && name === livePageViewExperienceName);
    const liveViewExperienceAborted = events.find(({ action: action, name: name })=>action === 'taskAbort' && name === livePageViewExperienceName);
    if (liveEditExperienceFailed || liveViewExperienceFailed) experience.fail({
        error: new Error(`Live page ${liveViewExperienceFailed ? 'view' : 'edit'} experience failed`)
    });
    else if (liveEditExperienceAborted || liveViewExperienceAborted) experience.abort({
        reason: `Live page ${liveViewExperienceAborted ? 'view' : 'edit'} experience aborted`
    });
};
function $04a7907e02801b8f$export$30ee8512ff42aa4() {
    const { livePageReleasePhase: livePageReleasePhase } = (0, $gTyTP.useIsLivePagesFeatureEnabled)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ln0hx.ExperienceStart), {
        name: (0, $irVI7.LIVE_PAGE_SESSION_EXPERIENCE),
        collect: $04a7907e02801b8f$var$livePageSessionCollect,
        attributes: {
            livePageReleasePhase: livePageReleasePhase
        }
    });
}

});

parcelRegister("cnsMc", function(module, exports) {

$parcel$export(module.exports, "LivePageShortcuts", () => $68618a608adea48b$export$3d3879943f164d00);

var $gwFzn = parcelRequire("gwFzn");

var $efvKr = parcelRequire("efvKr");

var $ljm2R = parcelRequire("ljm2R");
const $68618a608adea48b$var$shortcutConfigs = [
    {
        requiredModeForShortcut: 'view',
        requiresEditPermissions: true,
        shortcut: (0, $ljm2R.LIVE_PAGE_MODE_SWITCH_TO_EDIT),
        targetMode: 'edit'
    },
    {
        requiredModeForShortcut: 'edit',
        shortcut: (0, $ljm2R.LIVE_PAGE_MODE_SWITCH_TO_VIEW),
        targetMode: 'view'
    }
];
const $68618a608adea48b$export$3d3879943f164d00 = ({ canEdit: canEdit })=>{
    const [{ mode: mode }, { setMode: setMode }] = (0, $efvKr.useLivePageMode)();
    const handleModeChange = (nextMode)=>{
        if (mode !== nextMode) setMode(nextMode);
    };
    const applicableShortcuts = $68618a608adea48b$var$shortcutConfigs.filter(({ requiredModeForShortcut: requiredModeForShortcut, requiresEditPermissions: requiresEditPermissions })=>{
        // Check if the shortcut is relevant for the current mode
        const isModeApplicable = mode === requiredModeForShortcut;
        // Check if the shortcut requires any permissions. If it does, the users permissions should match the permissions to use the shortcut
        const hasEditPermissions = !requiresEditPermissions || requiresEditPermissions && canEdit;
        return isModeApplicable && hasEditPermissions;
    });
    if (applicableShortcuts.length === 0) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, applicableShortcuts.map(({ requiredModeForShortcut: requiredModeForShortcut, shortcut: shortcut, targetMode: targetMode })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ljm2R.ShortcutListener), {
            key: `${requiredModeForShortcut}-${shortcut}`,
            accelerator: shortcut,
            listener: ()=>handleModeChange(targetMode)
        })));
};

});

parcelRegister("3qFZr", function(module, exports) {

$parcel$export(module.exports, "StartLivePageLoad", () => $e515ddeaaacc482b$export$22d97e8b0fdc8888);

var $gwFzn = parcelRequire("gwFzn");

var $ipPpS = parcelRequire("ipPpS");

var $bQm3c = parcelRequire("bQm3c");

var $jX1qB = parcelRequire("jX1qB");
var $lSOAM = parcelRequire("lSOAM");
var $i3c1S = parcelRequire("i3c1S");
var $6VdZc = parcelRequire("6VdZc");
var $1UCmC = parcelRequire("1UCmC");
var $7fw2E = parcelRequire("7fw2E");

var $7sK8i = parcelRequire("7sK8i");

var $8w1c1 = parcelRequire("8w1c1");

var $1q7H7 = parcelRequire("1q7H7");

var $14SPd = parcelRequire("14SPd");

var $gw4Bt = parcelRequire("gw4Bt");

var $aWrnw = parcelRequire("aWrnw");

var $fgdVB = parcelRequire("fgdVB");

var $5qUgM = parcelRequire("5qUgM");

var $3VbV8 = parcelRequire("3VbV8");

var $kmyZQ = parcelRequire("kmyZQ");

var $9wGTI = parcelRequire("9wGTI");

var $hfPJk = parcelRequire("hfPJk");
const $e515ddeaaacc482b$var$baseConfig = {
    histogram: {
        initial: {
            fmp: '5000_6000_7000_8000_10000_12000_14000',
            tti: '5000_6000_7000_8000_10000_12000_14000'
        },
        transition: {
            fmp: '2000_2500_3000_3500_4000_4500_5000',
            tti: '2000_2500_3000_3500_4000_4500_5000'
        }
    },
    timings: [
        // breakdowns in order of occurrence
        {
            key: 'html',
            endMark: 'html'
        },
        {
            key: 'appLoad',
            startMark: 'html',
            endMark: 'app'
        },
        {
            key: 'appRootRender',
            startMark: 'app',
            endMark: 'root-component-render'
        },
        {
            key: 'routerMatched',
            startMark: 'root-component-render',
            endMark: 'route-manager-initialized'
        }
    ]
};
const $e515ddeaaacc482b$var$NOOP = ()=>{};
const $e515ddeaaacc482b$export$2d5e2a82ee58820b = ({ isAnonymous: isAnonymous, isInitialLoad: isInitialLoad, viewMode: viewMode, isUSDEnabled: isUSDEnabled })=>{
    const segments = [
        (0, $3VbV8.EDITOR_METRIC)
    ];
    if ((0, $9wGTI.fg)('confluence_frontend_object_sidebar')) segments.push((0, $fgdVB.OBJECT_SIDEBAR_CONTROL_METRIC));
    if ((0, $9wGTI.fg)('confluence_frontend_object_header')) segments.push((0, $5qUgM.OBJECT_HEADER_SEGMENT_METRIC));
    if (isInitialLoad) segments.push((0, $8w1c1.APP_NAVIGATION_METRIC), (0, $aWrnw.SPACE_NAVIGATION_METRIC), (0, $1q7H7.PAGE_TREE_METRIC));
    if (!isAnonymous && !viewMode) {
        if (isUSDEnabled) segments.push((0, $gw4Bt.SHARE_BUTTON_PAGE_SEGMENT_LOAD));
        else segments.push((0, $14SPd.RESTRICTIONS_BUTTON_METRIC));
    }
    return segments;
};
/**
 * fmpAsUntilStopTimeMetrics
 *
 * UPDATE 2025-04-29: TTI is deprecated. Going forward, new segments should be included here by default in order to
 * preserve the original TTI definition. Segments should be included even if they are not minimally interactive.
 *
 * What is minimally interactive?
 * Minimally interactive during the SSR phase at it's core, is determined if the component/element is clickable,
 * can register the action, and display a visual response that the action has been received.
 * The SSR phase can be stalled by appending ?NO_SPA=1 at the end of a CONNIE url.
 *
 * I.E. If you click on an inline comment/highlight, the click is registered, and displays a loading sidebar component.
 *
 * If a required segment is SSR'd and determined to be minimally interactive at FMP, ADD TO THIS LIST
 * If a required segment is SSR'd but determined to NOT be minimally interactive at FMP, DO NOT ADD TO THIS LIST
 * If a required segment is yet to be SSR'd, this config will not update TTI for that segment, by default is OFF.
 *
 * CONTEXT
 * the returned segments are considered to be minimally interactive during SSR
 * hence we want to use FMP (ssr-ttr mark)
 *
 * PageSegment TTI is measured: useFmpAsUntilStopTime ? FMP : Eventual load time
 * Content-renderer TTI: macros are SSRed ? FMP : Eventual Load Time
 *
 * View Page TTI is measured: Math.max(Non SSR PageSegments TTI, Content-renderer TTI)
 *
 */ const $e515ddeaaacc482b$var$fmpAsUntilStopTimeMetrics = (isUSDEnabled)=>{
    return [
        (0, $jX1qB.APP_NAVIGATION_SEGMENT_KEY),
        (0, $jX1qB.SPACE_NAVIGATION_SEGMENT_KEY),
        (0, $jX1qB.PAGE_TREE_SEGMENT_KEY),
        (0, $jX1qB.OBJECT_HEADER_SEGMENT_KEY),
        (0, $jX1qB.OBJECT_SIDEBAR_CONTROL_SEGMENT_KEY),
        isUSDEnabled ? (0, $jX1qB.SHARE_BUTTON_SEGMENT_KEY) : (0, $jX1qB.RESTRICTIONS_BUTTON_SEGMENT_KEY)
    ];
};
const $e515ddeaaacc482b$export$22d97e8b0fdc8888 = ({ contentId: contentId, viewMode: viewMode })=>{
    const { userId: userId } = (0, $bQm3c.useSessionData)();
    const pageLoadMetricRef = (0, $gwFzn.useRef)();
    const progressBarRef = (0, $gwFzn.useRef)(null);
    const { isUSDExperimentEnabled: isUSDExperimentEnabled } = (0, $hfPJk.useUnifiedShareDialogEligible)();
    // Create a page-load metric that will be finished based on the timings of each
    // of page-segment-load metrics we expect to see fired
    (0, $gwFzn.useEffect)(()=>{
        const _isInitialLoad = (0, $6VdZc.isInitial)();
        const expectedPageSegments = $e515ddeaaacc482b$export$2d5e2a82ee58820b({
            isAnonymous: Boolean(!userId),
            isInitialLoad: _isInitialLoad,
            viewMode: viewMode,
            isUSDEnabled: (0, $9wGTI.fg)('confluence_frontend_unified_restrict_and_share') || isUSDExperimentEnabled
        });
        const untilExperienceMetricNames = $e515ddeaaacc482b$var$fmpAsUntilStopTimeMetrics((0, $9wGTI.fg)('confluence_frontend_unified_restrict_and_share') || isUSDExperimentEnabled);
        // Create a list of untilPageSegments
        // This wraps the segments into an UntilExperience, so that @atlassian/browser-metrics can handle useFmpAsUntilStopTime gracefully
        // Note - this only affect initial load since transitions are not SSR'd, hence page-segments do not have fmp marks
        // More information why useFmpAsUntilStopTime can be found here
        // https://hello.atlassian.net/wiki/spaces/~484600559/pages/1515596554/Toolings+Update+Browser-Metrics+FMP+TTI
        const untilPageSegments = expectedPageSegments.map((segment)=>({
                experience: segment,
                useFmpAsUntilStopTime: untilExperienceMetricNames.includes(segment.key)
            }));
        pageLoadMetricRef.current = (0, $lSOAM.createPageLoadMetric)({
            ...$e515ddeaaacc482b$var$baseConfig,
            key: (0, $1UCmC.LIVE_PAGE_LOAD_KEY),
            timings: [
                ...$e515ddeaaacc482b$var$baseConfig.timings,
                ...(0, $i3c1S.getWaterfallTimings)(expectedPageSegments)
            ],
            include: expectedPageSegments,
            until: untilPageSegments,
            reactUFOName: (0, $1UCmC.LIVE_PAGE_REACT_UFO_LOAD_KEY)
        });
        if (!_isInitialLoad) // Make sure all segments are re-started and not currently marked as finished from a previous navigation
        expectedPageSegments.forEach((m)=>m.startFromPageLoad());
        pageLoadMetricRef.current.startPageLoad();
        pageLoadMetricRef.current.onStop(()=>{
            (0, $7fw2E.markBrowserMetricEnd)(pageLoadMetricRef.current);
            progressBarRef.current?.finish();
        }, $e515ddeaaacc482b$var$NOOP);
        pageLoadMetricRef.current.onStop((0, $7sK8i.resumeLowPriorityEvents), (0, $7sK8i.resumeLowPriorityEvents));
        // Cleanup on unmount or when dependencies have changed
        return ()=>{
            pageLoadMetricRef.current?.cancel();
            progressBarRef.current = null;
        };
    }, [
        contentId,
        userId,
        viewMode,
        isUSDExperimentEnabled
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ipPpS.Subscribe), {
        to: [
            (0, $kmyZQ.ProgressBarContainer)
        ]
    }, (progressBar)=>{
        progressBarRef.current = progressBar;
        return null;
    });
};

});
parcelRegister("jX1qB", function(module, exports) {

$parcel$export(module.exports, "APP_NAVIGATION_SEGMENT_KEY", () => $fa0ea3428ec5aa62$export$9e40500efe28ac9e);
$parcel$export(module.exports, "BLOG_TREE_SEGMENT_KEY", () => $fa0ea3428ec5aa62$export$38b273cdbbf56c26);
$parcel$export(module.exports, "BYLINE_SEGMENT_KEY", () => $fa0ea3428ec5aa62$export$1ac23cd5807df863);
$parcel$export(module.exports, "READ_TIME_SEGMENT_KEY", () => $fa0ea3428ec5aa62$export$5bbb36bee09a5671);
$parcel$export(module.exports, "CONTENT_ANALYTICS_VIEWERS_SEGMENT_KEY", () => $fa0ea3428ec5aa62$export$a79607497a4a710c);
$parcel$export(module.exports, "CONTENT_ANALYTICS_LINKS_TABLE_SEGMENT_KEY", () => $fa0ea3428ec5aa62$export$c56a99673f1bb7bb);
$parcel$export(module.exports, "CONTENT_RENDERER_SEGMENT_KEY", () => $fa0ea3428ec5aa62$export$140a493a9e781fe2);
$parcel$export(module.exports, "CONTENT_TITLE_SEGMENT_KEY", () => $fa0ea3428ec5aa62$export$db1285ccb0399c01);
$parcel$export(module.exports, "FAVOURITE_BUTTON_SEGMENT_KEY", () => $fa0ea3428ec5aa62$export$eb5bb54418693284);
$parcel$export(module.exports, "FOCUSED_INLINE_COMMENT_SEGMENT_KEY", () => $fa0ea3428ec5aa62$export$3fde425dbc74423b);
$parcel$export(module.exports, "INLINE_COMMENTS_HIGHLIGHTS_SEGMENT_KEY", () => $fa0ea3428ec5aa62$export$6a58cce6529da40e);
$parcel$export(module.exports, "FABRIC_COMMENTS_HIGHLIGHTS_SEGMENT_KEY", () => $fa0ea3428ec5aa62$export$8910bc840e3ee4ce);
$parcel$export(module.exports, "RENDERER_INLINE_COMMENT_RENDER_SEGMENT_KEY", () => $fa0ea3428ec5aa62$export$bf572571ca036b67);
$parcel$export(module.exports, "EDITOR_INLINE_COMMENT_RENDER_SEGMENT_KEY", () => $fa0ea3428ec5aa62$export$644778267d4a4a82);
$parcel$export(module.exports, "MEDIA_SEGMENT_KEY", () => $fa0ea3428ec5aa62$export$7416ef7ed24ec47f);
$parcel$export(module.exports, "PAGE_COMMENTS_SEGMENT_KEY", () => $fa0ea3428ec5aa62$export$e4ff10a0a39a7217);
$parcel$export(module.exports, "PAGE_REACTIONS_SEGMENT_KEY", () => $fa0ea3428ec5aa62$export$6648c9be174e6923);
$parcel$export(module.exports, "FEED_REACTIONS_SEGMENT_KEY", () => $fa0ea3428ec5aa62$export$2d3d6144128aaee3);
$parcel$export(module.exports, "PAGE_TREE_SEGMENT_KEY", () => $fa0ea3428ec5aa62$export$2f4a07b2ab7a5499);
$parcel$export(module.exports, "RESTRICTIONS_BUTTON_SEGMENT_KEY", () => $fa0ea3428ec5aa62$export$d1dfca9e0eb45581);
$parcel$export(module.exports, "GLOBAL_NAVIGATION_SEGMENT_KEY", () => $fa0ea3428ec5aa62$export$312db7b759bad970);
$parcel$export(module.exports, "SPACE_NAVIGATION_SEGMENT_KEY", () => $fa0ea3428ec5aa62$export$cf2a6bf49e73b304);
$parcel$export(module.exports, "SPACE_APPS_SEGMENT_KEY", () => $fa0ea3428ec5aa62$export$84f6b5717c3fb962);
$parcel$export(module.exports, "WATCH_BUTTON_SEGMENT_KEY", () => $fa0ea3428ec5aa62$export$1a423f2548c46be3);
$parcel$export(module.exports, "HOME_OVERVIEW_RECENT_SEGMENT_KEY", () => $fa0ea3428ec5aa62$export$b6426c6941656619);
$parcel$export(module.exports, "HOME_OVERVIEW_FEED_SEGMENT_KEY", () => $fa0ea3428ec5aa62$export$14f30a91623dfcf3);
$parcel$export(module.exports, "HOME_OVERVIEW_RIGHT_PANEL_SEGMENT_KEY", () => $fa0ea3428ec5aa62$export$c6926beb57b60636);
$parcel$export(module.exports, "HOME_OVERVIEW_SPACES_SECTION_SEGMENT_KEY", () => $fa0ea3428ec5aa62$export$687913e127f52cc3);
$parcel$export(module.exports, "HOME_RECENTS_VIEW_SEGMENT_KEY", () => $fa0ea3428ec5aa62$export$2d52eeb1a0271bf0);
$parcel$export(module.exports, "HOME_STARRED_VIEW_SEGMENT_KEY", () => $fa0ea3428ec5aa62$export$76243e8aa4afaa0b);
$parcel$export(module.exports, "HOME_DRAFTS_VIEW_SEGMENT_KEY", () => $fa0ea3428ec5aa62$export$e1df6f3f29083f48);
$parcel$export(module.exports, "END_OF_PAGE_RECOMMENDATIONS_SEGMENT_KEY", () => $fa0ea3428ec5aa62$export$7b32848c9413526a);
$parcel$export(module.exports, "IN_EDITOR_TEMPLATES_SEGMENT_KEY", () => $fa0ea3428ec5aa62$export$58fbb0ba50341103);
$parcel$export(module.exports, "NCS_CONNECTED_FMP_KEY", () => $fa0ea3428ec5aa62$export$4f481f063369df3c);
$parcel$export(module.exports, "ADVANCED_SEARCH_COMPONENT_SEGMENT_KEY", () => $fa0ea3428ec5aa62$export$db1b9793e009e605);
$parcel$export(module.exports, "ADVANCED_SEARCH_FILTER_SECTION_SEGMENT_KEY", () => $fa0ea3428ec5aa62$export$90bda069d4bf981b);
$parcel$export(module.exports, "ADVANCED_SEARCH_RESULT_SECTION_SEGMENT_KEY", () => $fa0ea3428ec5aa62$export$f11e1d4269141c0e);
$parcel$export(module.exports, "DATABASE_HEADER_SEGMENT_METRIC_KEY", () => $fa0ea3428ec5aa62$export$f0298cbab4a44998);
$parcel$export(module.exports, "SMART_LINK_EMBED_HEADER_SEGMENT_METRIC_KEY", () => $fa0ea3428ec5aa62$export$fa02a8e56ccc9d5);
$parcel$export(module.exports, "WHITEBOARD_HEADER_SEGMENT_METRIC_KEY", () => $fa0ea3428ec5aa62$export$cf2f52fec740bdea);
$parcel$export(module.exports, "OBJECT_HEADER_SEGMENT_KEY", () => $fa0ea3428ec5aa62$export$52050233077a1838);
$parcel$export(module.exports, "CONTENT_TYPES_HEADER_TITLE_SEGMENT_KEY", () => $fa0ea3428ec5aa62$export$e1ab333f0b70b317);
$parcel$export(module.exports, "WHITEBOARD_VIEW_PAGE_CONTENT_SEGMENT_KEY", () => $fa0ea3428ec5aa62$export$b6a22e6ed7750ea4);
$parcel$export(module.exports, "DATABASE_VIEW_PAGE_CONTENT_SEGMENT_KEY", () => $fa0ea3428ec5aa62$export$b95bd4bfc46932fc);
$parcel$export(module.exports, "SHARE_BUTTON_SEGMENT_KEY", () => $fa0ea3428ec5aa62$export$bf838b84ba2f7b95);
$parcel$export(module.exports, "VIEW_PAGE_LABELS_METRIC_KEY", () => $fa0ea3428ec5aa62$export$79910402df6be117);
$parcel$export(module.exports, "ADMIN_ANNOUNCEMENT_BANNER_SEGMENT_KEY", () => $fa0ea3428ec5aa62$export$d86af34f7dc194b4);
$parcel$export(module.exports, "CONNECT_APP_WEB_FRAGMENT_SEGMENT_KEY", () => $fa0ea3428ec5aa62$export$ae588ea5fb9e92bb);
$parcel$export(module.exports, "SPACE_PERMISSIONS_SEGMENT_KEY", () => $fa0ea3428ec5aa62$export$1939caa7fae28ef5);
$parcel$export(module.exports, "VIEW_PAGE_CONTAINER_SEGMENT_KEY", () => $fa0ea3428ec5aa62$export$3f06ee123a5ad183);
$parcel$export(module.exports, "EMBED_VIEW_PAGE_CONTENT_SEGMENT_KEY", () => $fa0ea3428ec5aa62$export$37da6122cd60d332);
$parcel$export(module.exports, "EMBED_VIEW_PAGE_BLANK_CONTENT_SEGMENT_KEY", () => $fa0ea3428ec5aa62$export$3437c1f145cfce19);
$parcel$export(module.exports, "EDITOR_SEGMENT_KEY", () => $fa0ea3428ec5aa62$export$7903037283afbce0);
$parcel$export(module.exports, "RECAP_MODAL_SEGMENT_KEY", () => $fa0ea3428ec5aa62$export$fdd1a35fb559480a);
$parcel$export(module.exports, "OBJECT_SIDEBAR_CONTROL_SEGMENT_KEY", () => $fa0ea3428ec5aa62$export$31d10d7597db11d3);
// "confluence.fe.page-segment-load.XXX"
const $fa0ea3428ec5aa62$export$9e40500efe28ac9e = 'app-navigation';
const $fa0ea3428ec5aa62$export$38b273cdbbf56c26 = 'blog-tree';
const $fa0ea3428ec5aa62$export$1ac23cd5807df863 = 'byline';
const $fa0ea3428ec5aa62$export$5bbb36bee09a5671 = 'read-time';
const $fa0ea3428ec5aa62$export$a79607497a4a710c = 'content-analytics-viewers';
const $fa0ea3428ec5aa62$export$c56a99673f1bb7bb = 'content-analytics-links-table';
const $fa0ea3428ec5aa62$export$140a493a9e781fe2 = 'content-renderer';
const $fa0ea3428ec5aa62$export$db1285ccb0399c01 = 'content-title';
const $fa0ea3428ec5aa62$export$eb5bb54418693284 = 'favourite-button';
const $fa0ea3428ec5aa62$export$3fde425dbc74423b = 'focused-inline-comment';
const $fa0ea3428ec5aa62$export$6a58cce6529da40e = 'inline-comments-highlights';
const $fa0ea3428ec5aa62$export$8910bc840e3ee4ce = 'fabric-comments-highlights';
const $fa0ea3428ec5aa62$export$bf572571ca036b67 = 'render-inline-comment';
const $fa0ea3428ec5aa62$export$644778267d4a4a82 = 'editor-render-inline-comment';
const $fa0ea3428ec5aa62$export$3afb71dd0b0dbc3a = 'reactions';
const $fa0ea3428ec5aa62$export$7416ef7ed24ec47f = 'media';
const $fa0ea3428ec5aa62$export$e4ff10a0a39a7217 = 'page-comments';
const $fa0ea3428ec5aa62$export$6648c9be174e6923 = 'page-reactions';
const $fa0ea3428ec5aa62$export$2d3d6144128aaee3 = 'feed-reactions';
const $fa0ea3428ec5aa62$export$2f4a07b2ab7a5499 = 'page-tree';
const $fa0ea3428ec5aa62$export$d1dfca9e0eb45581 = 'restrictions-button';
const $fa0ea3428ec5aa62$export$312db7b759bad970 = 'global-navigation';
const $fa0ea3428ec5aa62$export$cf2a6bf49e73b304 = 'space-navigation';
const $fa0ea3428ec5aa62$export$84f6b5717c3fb962 = 'space-apps';
const $fa0ea3428ec5aa62$export$1a423f2548c46be3 = 'watch-button';
const $fa0ea3428ec5aa62$export$b6426c6941656619 = 'home-overview-recent';
const $fa0ea3428ec5aa62$export$14f30a91623dfcf3 = 'home-overview-feed';
const $fa0ea3428ec5aa62$export$c6926beb57b60636 = 'home-overview-right-panel';
const $fa0ea3428ec5aa62$export$687913e127f52cc3 = 'home-overview-spaces-section';
const $fa0ea3428ec5aa62$export$2d52eeb1a0271bf0 = 'home-recents-view';
const $fa0ea3428ec5aa62$export$76243e8aa4afaa0b = 'home-starred-view';
const $fa0ea3428ec5aa62$export$e1df6f3f29083f48 = 'home-drafts-view';
const $fa0ea3428ec5aa62$export$7b32848c9413526a = 'end-of-page-recommendations';
const $fa0ea3428ec5aa62$export$58fbb0ba50341103 = 'in-editor-templates';
const $fa0ea3428ec5aa62$export$4f481f063369df3c = 'ncs-connected-fmp';
const $fa0ea3428ec5aa62$export$db1b9793e009e605 = 'advanced-search-component';
const $fa0ea3428ec5aa62$export$90bda069d4bf981b = 'advanced-search-filter-section';
const $fa0ea3428ec5aa62$export$f11e1d4269141c0e = 'advanced-search-result-section';
const $fa0ea3428ec5aa62$export$f0298cbab4a44998 = 'database-header';
const $fa0ea3428ec5aa62$export$fa02a8e56ccc9d5 = 'smart-link-embed-header';
const $fa0ea3428ec5aa62$export$cf2f52fec740bdea = 'whiteboard-header';
const $fa0ea3428ec5aa62$export$52050233077a1838 = 'object-header';
const $fa0ea3428ec5aa62$export$e1ab333f0b70b317 = 'content-types-header-title';
const $fa0ea3428ec5aa62$export$b6a22e6ed7750ea4 = 'whiteboard-view-page-content';
const $fa0ea3428ec5aa62$export$b95bd4bfc46932fc = 'database-view-page-content';
const $fa0ea3428ec5aa62$export$bf838b84ba2f7b95 = 'share-button';
const $fa0ea3428ec5aa62$export$79910402df6be117 = 'view-page-labels';
const $fa0ea3428ec5aa62$export$d86af34f7dc194b4 = 'admin-announcement-banner';
const $fa0ea3428ec5aa62$export$ae588ea5fb9e92bb = 'cp-web-fragment';
const $fa0ea3428ec5aa62$export$1939caa7fae28ef5 = 'view-space-permissions';
const $fa0ea3428ec5aa62$export$3f06ee123a5ad183 = 'view-page-container';
const $fa0ea3428ec5aa62$export$37da6122cd60d332 = 'embed-view-page-content';
const $fa0ea3428ec5aa62$export$3437c1f145cfce19 = 'embed-view-page-blank-content';
const $fa0ea3428ec5aa62$export$7903037283afbce0 = 'editor';
const $fa0ea3428ec5aa62$export$fdd1a35fb559480a = 'recap-modal';
const $fa0ea3428ec5aa62$export$31d10d7597db11d3 = 'object-sidebar-control';

});

parcelRegister("lSOAM", function(module, exports) {

$parcel$export(module.exports, "isBMPageLoad", () => $2a47a9fc48674e91$export$9dede01b6f349441);
$parcel$export(module.exports, "hasBMPageLoadStarted", () => $2a47a9fc48674e91$export$cb339d0cd5cc821c);
$parcel$export(module.exports, "createPageLoadMetric", () => $2a47a9fc48674e91$export$c5aa7fcaede4a84d);
$parcel$export(module.exports, "createCustomMetric", () => $2a47a9fc48674e91$export$19ba7be4fcf34f3d);
$parcel$export(module.exports, "createInteractionMetric", () => $2a47a9fc48674e91$export$36d7a61d0660e29c);
$parcel$export(module.exports, "createPageSegmentLoadMetric", () => $2a47a9fc48674e91$export$34f706592a2f7442);
$parcel$export(module.exports, "createConcurrentCustomMetric", () => $2a47a9fc48674e91$export$9db2e0f538bb10fa);
/* eslint-disable no-restricted-syntax */ 
var $3kTfj = parcelRequire("3kTfj");
var $kyiqo = parcelRequire("kyiqo");

var $64KID = parcelRequire("64KID");

var $i3c1S = parcelRequire("i3c1S");
const $2a47a9fc48674e91$export$d539c641d560c25d = new Set([
    (0, $64KID.namedRoutes).CREATE_BLOG.name,
    (0, $64KID.namedRoutes).CREATE_BLOG_ACTION_LEGACY.name,
    (0, $64KID.namedRoutes).CREATE_PAGE.name,
    (0, $64KID.namedRoutes).CREATE_PAGE_ACTION_LEGACY.name,
    (0, $64KID.namedRoutes).EDIT_BLOG.name,
    (0, $64KID.namedRoutes).EDIT_BLOG_V2.name,
    (0, $64KID.namedRoutes).EDIT_PAGE.name,
    (0, $64KID.namedRoutes).EDIT_PAGE_V2.name,
    (0, $64KID.namedRoutes).EDIT_PAGE_EMBED.name,
    (0, $64KID.namedRoutes).VIEW_PAGE.name,
    (0, $64KID.namedRoutes).VIEW_BLOG.name,
    (0, $64KID.namedRoutes).VIEW_BLOG_DATE_LEGACY.name,
    (0, $64KID.namedRoutes).SPACE_INDEX.name,
    (0, $64KID.namedRoutes).SPACE_OVERVIEW.name,
    (0, $64KID.namedRoutes).TEMPLATE_GALLERY.name,
    (0, $64KID.namedRoutes).CONTENT_HISTORY.name,
    (0, $64KID.namedRoutes).ADVANCED_SEARCH.name,
    (0, $64KID.namedRoutes).HOME.name,
    (0, $64KID.namedRoutes).SPACE_DIRECTORY.name,
    (0, $64KID.namedRoutes).SPACE_PAGES.name
]);
const $2a47a9fc48674e91$export$9dede01b6f349441 = (match)=>{
    if (!match) return false;
    return $2a47a9fc48674e91$export$d539c641d560c25d.has(match.name);
};
const $2a47a9fc48674e91$export$cb339d0cd5cc821c = ()=>{
    const currentMetric = (0, $3kTfj.browserMetrics).getPageLoadMetric();
    return currentMetric.getData().start !== null;
};
const { pageLoad: $2a47a9fc48674e91$export$c5aa7fcaede4a84d, custom: $2a47a9fc48674e91$export$19ba7be4fcf34f3d, interaction: $2a47a9fc48674e91$export$36d7a61d0660e29c, pageSegmentLoad: $2a47a9fc48674e91$export$34f706592a2f7442, concurrent: $2a47a9fc48674e91$var$concurrent } = (0, $kyiqo.metrics);
const $2a47a9fc48674e91$export$9db2e0f538bb10fa = $2a47a9fc48674e91$var$concurrent.custom;

});
parcelRegister("kyiqo", function(module, exports) {

$parcel$export(module.exports, "metrics", () => $64dffbb6f4d5c9a0$export$b0c5c2fac8144e54);

var $bCz2F = parcelRequire("bCz2F");

var $bs5rD = parcelRequire("bs5rD");
const $64dffbb6f4d5c9a0$export$b0c5c2fac8144e54 = {
    pageLoad: $bs5rD.pageLoad,
    pageSegmentLoad: $bs5rD.pageSegmentLoad,
    interaction: $bs5rD.interaction,
    custom: $bs5rD.custom,
    concurrent: $bCz2F.concurrent
};

});
parcelRegister("bCz2F", function(module, exports) {

$parcel$export(module.exports, "concurrent", () => $bbc3e125622b0c90$export$370df09ecc3de059);

var $j4jXg = parcelRequire("j4jXg");

var $bs5rD = parcelRequire("bs5rD");
const $bbc3e125622b0c90$var$concurrentMetrics = {};
const $bbc3e125622b0c90$var$getKey = (config, type)=>`${type}--${config.key}`;
const $bbc3e125622b0c90$var$validateConfig = (config)=>{
    if (config.include) throw new Error('"include" is not supported in concurrent actions');
    if (config.until) throw new Error('"until" is not supported in concurrent actions');
};
const $bbc3e125622b0c90$var$ensurePath = (config, type)=>{
    const key = $bbc3e125622b0c90$var$getKey(config, type);
    if (!(key in $bbc3e125622b0c90$var$concurrentMetrics)) $bbc3e125622b0c90$var$concurrentMetrics[key] = {};
};
const $bbc3e125622b0c90$var$getMetricFromCache = (concurrentId, config, type)=>{
    const concurrentKey = $bbc3e125622b0c90$var$getKey(config, type);
    if (concurrentKey in $bbc3e125622b0c90$var$concurrentMetrics && $bbc3e125622b0c90$var$concurrentMetrics[concurrentKey][String(concurrentId)]) return $bbc3e125622b0c90$var$concurrentMetrics[concurrentKey][String(concurrentId)];
    if (!(concurrentKey in $bbc3e125622b0c90$var$concurrentMetrics)) $bbc3e125622b0c90$var$concurrentMetrics[concurrentKey] = {};
};
const $bbc3e125622b0c90$var$makeConcurrentMetric = (concurrentId, config, type)=>{
    $bbc3e125622b0c90$var$validateConfig(config);
    $bbc3e125622b0c90$var$ensurePath(config, type);
    const metricFromCache = $bbc3e125622b0c90$var$getMetricFromCache(concurrentId, config, type);
    if (metricFromCache) return metricFromCache;
    const metricFactory = type === (0, $j4jXg.BMEventsType).INLINE_RESULT ? (0, $bs5rD.interaction) : (0, $bs5rD.custom);
    const metric = metricFactory(config);
    $bbc3e125622b0c90$var$concurrentMetrics[$bbc3e125622b0c90$var$getKey(config, type)][String(concurrentId)] = metric;
    return metric;
};
const $bbc3e125622b0c90$export$370df09ecc3de059 = {
    pageSegmentLoad: (config)=>(concurrentId)=>$bbc3e125622b0c90$var$makeConcurrentMetric(concurrentId, {
                ...config
            }, (0, $j4jXg.BMEventsType).PAGE_SEGMENT_LOAD),
    interaction: (config)=>(concurrentId)=>$bbc3e125622b0c90$var$makeConcurrentMetric(concurrentId, {
                ...config
            }, (0, $j4jXg.BMEventsType).INLINE_RESULT),
    custom: (config)=>(concurrentId)=>$bbc3e125622b0c90$var$makeConcurrentMetric(concurrentId, {
                ...config
            }, (0, $j4jXg.BMEventsType).CUSTOM)
};

});
parcelRegister("bs5rD", function(module, exports) {

$parcel$export(module.exports, "pageLoad", () => $d0aae4122f29b5ae$export$791d520f7e8058a5);
$parcel$export(module.exports, "pageSegmentLoad", () => $d0aae4122f29b5ae$export$94114666844d5f66);
$parcel$export(module.exports, "interaction", () => $d0aae4122f29b5ae$export$92473e6020ad89b4);
$parcel$export(module.exports, "custom", () => $d0aae4122f29b5ae$export$4c00f665f0d4b443);

var $iuio5 = parcelRequire("iuio5");

var $boXf9 = parcelRequire("boXf9");

var $giQku = parcelRequire("giQku");

var $j4jXg = parcelRequire("j4jXg");
const $d0aae4122f29b5ae$export$791d520f7e8058a5 = (config)=>{
    return new (0, $boXf9.PageLoadMetric)({
        ...config,
        type: (0, $j4jXg.BMEventsType).PAGE_LOAD
    });
};
const $d0aae4122f29b5ae$export$94114666844d5f66 = (config)=>{
    return new (0, $giQku.PageSegmentLoadMetric)({
        ...config,
        type: (0, $j4jXg.BMEventsType).PAGE_SEGMENT_LOAD
    });
};
const $d0aae4122f29b5ae$export$92473e6020ad89b4 = (config)=>{
    return new (0, $iuio5.Metric)({
        ...config,
        type: (0, $j4jXg.BMEventsType).INLINE_RESULT
    });
};
const $d0aae4122f29b5ae$export$4c00f665f0d4b443 = (config)=>{
    return new (0, $iuio5.Metric)({
        ...config,
        type: (0, $j4jXg.BMEventsType).CUSTOM
    });
};

});
parcelRegister("iuio5", function(module, exports) {

$parcel$export(module.exports, "Metric", () => $6456fd2c244bded5$export$efdd3e096bc27746);

var $lH7GJ = parcelRequire("lH7GJ");

var $11Zqj = parcelRequire("11Zqj");

var $4k3LC = parcelRequire("4k3LC");
class $6456fd2c244bded5$export$efdd3e096bc27746 extends (0, $4k3LC.BaseMetric) {
    start({ startTime: startTime } = {}) {
        super.start({
            startTime: startTime
        });
        this.route = (0, $lH7GJ.Route).getRoute();
    }
    stop(params = {}) {
        const stoppedSuccessfully = super.stop(params);
        if (stoppedSuccessfully && !this.config.virtual) (0, $11Zqj.submitter).queue(this.getData());
        return stoppedSuccessfully;
    }
}

});

parcelRegister("boXf9", function(module, exports) {

$parcel$export(module.exports, "PageLoadMetric", () => $b4ce8d24635e776a$export$3c51073271a9eac3);

var $h6RR2 = parcelRequire("h6RR2");

var $7RgFv = parcelRequire("7RgFv");

var $lH7GJ = parcelRequire("lH7GJ");

var $11Zqj = parcelRequire("11Zqj");

var $j4jXg = parcelRequire("j4jXg");

var $3znwT = parcelRequire("3znwT");

var $69Zr8 = parcelRequire("69Zr8");

var $e9ZCR = parcelRequire("e9ZCR");
class $b4ce8d24635e776a$export$3c51073271a9eac3 extends (0, $3znwT.BasePageLoadMetric) {
    startPageLoad(params = {
        isInitial: false
    }) {
        (0, $69Zr8.pageLoadMetaMetric).startPageLoad({
            ...params,
            cancelStarted: 'startTime' in params
        });
        this.watchUntil();
    }
    stop(params = {}) {
        const stopTime = params.stopTime || window.performance.now();
        const pageLoadData = (0, $69Zr8.pageLoadMetaMetric).getDataToMerge();
        const metaMetricStopped = (0, $69Zr8.pageLoadMetaMetric).stop(params);
        if (!metaMetricStopped) return false;
        if (pageLoadData.isInitial && this.config.ssr?.doneAsFmp) {
            if (!this.marks[(0, $3znwT.BasePageLoadMetric).FMP]) {
                const mark = (0, $h6RR2.SSRGetDoneMark).getDoneMark();
                if (mark) (0, $69Zr8.pageLoadMetaMetric).markFMP(mark);
            } else (0, $69Zr8.pageLoadMetaMetric).markFMP(this.marks[(0, $3znwT.BasePageLoadMetric).FMP]);
        }
        this.route = (0, $lH7GJ.Route).getRoute();
        const metricStopped = this.stopPageLoad(pageLoadData, {
            ...params,
            stopTime: stopTime
        });
        if (!metricStopped) return false;
        const data = this.getData();
        if (!this.config.virtual) (0, $11Zqj.submitter).queue(data);
        (0, $7RgFv.logger).logCond(!!this.config.debug, 'page-load', 'stop', this.getData);
        this.enqueueWebVitals();
        return true;
    }
    mark(mark, timestamp = window.performance.now()) {
        (0, $69Zr8.pageLoadMetaMetric).mark(mark, timestamp);
    }
    markFMP(timestamp) {
        (0, $69Zr8.pageLoadMetaMetric).markFMP(timestamp);
    }
    getData() {
        const pageLoadMetaData = (0, $69Zr8.pageLoadMetaMetric).getData();
        return {
            ...super.getData(),
            // marks and explicitTimings are available only in pageLoadMeta
            marks: pageLoadMetaData.marks,
            explicitTimings: pageLoadMetaData.explicitTimings
        };
    }
    async enqueueWebVitals() {
        if (this.config.virtual || !this.isInitial) return false;
        const configChunk = await (0, $11Zqj.submitter).config.configChunk;
        if (!configChunk?.[(0, $j4jXg.BMEventsType).WEB_VITALS].webVitals?.enabled) return false;
        const webVitalMetric = new (0, $e9ZCR.WebVitalsMetric)({
            key: this.config.key,
            route: this.route,
            startTime: this.startTime,
            stopTime: this.stopTime,
            pageVisibleState: this.pageVisibleState
        });
        (0, $11Zqj.submitter).queue(webVitalMetric.getData());
        (0, $7RgFv.logger).logCond(!!this.config.debug, 'web-vitals', webVitalMetric.getData);
        return true;
    }
}

});
parcelRegister("e9ZCR", function(module, exports) {

$parcel$export(module.exports, "WebVitalsMetric", () => $fd3d2d441d340510$export$dc0d85d4d6503cd7);

var $j4jXg = parcelRequire("j4jXg");

var $4k3LC = parcelRequire("4k3LC");
class $fd3d2d441d340510$export$dc0d85d4d6503cd7 extends (0, $4k3LC.BaseMetric) {
    constructor({ key: key, route: route, startTime: startTime, stopTime: stopTime, pageVisibleState: pageVisibleState }){
        super({
            type: (0, $j4jXg.BMEventsType).WEB_VITALS,
            key: key
        });
        this.route = route;
        this.startTime = startTime;
        this.stopTime = stopTime;
        this.state = (0, $4k3LC.MetricState).FINISHED;
        this.pageVisibleState = pageVisibleState;
    }
}

});


parcelRegister("giQku", function(module, exports) {

$parcel$export(module.exports, "PageSegmentLoadMetric", () => $4f83d9bff0211700$export$24c8bfcd77494cc1);

var $h6RR2 = parcelRequire("h6RR2");

var $j4jXg = parcelRequire("j4jXg");

var $4k3LC = parcelRequire("4k3LC");

var $iuio5 = parcelRequire("iuio5");

var $69Zr8 = parcelRequire("69Zr8");
class $4f83d9bff0211700$export$24c8bfcd77494cc1 extends (0, $iuio5.Metric) {
    startFromPageLoad() {
        const pageLoadMetaData = (0, $69Zr8.pageLoadMetaMetric).getData();
        this.start({
            startTime: pageLoadMetaData.start ?? undefined
        });
        this.isInitial = pageLoadMetaData.isInitial;
        this.pageVisibleState = pageLoadMetaData.pageVisibleState;
    }
    mark(mark, timestamp = window.performance.now()) {
        if (mark === $4f83d9bff0211700$export$24c8bfcd77494cc1.FMP) return;
        super.mark(mark, timestamp);
    }
    markFMP(timestamp) {
        super.mark($4f83d9bff0211700$export$24c8bfcd77494cc1.FMP, timestamp);
    }
    getPageSegmentLoadData() {
        return {
            isInitial: this.isInitial
        };
    }
    getData() {
        return {
            ...super.getData(),
            ...this.getPageSegmentLoadData()
        };
    }
    getDataToMerge() {
        return {
            ...super.getDataToMerge(),
            ...this.getPageSegmentLoadData()
        };
    }
    merge(mergeData) {
        super.merge(mergeData);
        this.isInitial = mergeData.isInitial;
    }
    stop(params = {}) {
        const pageLoadData = (0, $69Zr8.pageLoadMetaMetric).getData();
        if (pageLoadData.isInitial && this.config.ssr?.doneAsFmp) {
            if (!this.marks[$4f83d9bff0211700$export$24c8bfcd77494cc1.FMP]) {
                const mark = (0, $h6RR2.SSRGetDoneMark).getDoneMark();
                if (mark) this.markFMP(mark);
            }
        }
        if (this.config.includePageLoadTimings !== (0, $j4jXg.PageSegmentPageLoadMetricsOptions).WAIT_UNTIL_PRESENT || pageLoadData.state === (0, $4k3LC.MetricState).FINISHED) return super.stop(params);
        const now = performance.now();
        if (pageLoadData.state === (0, $4k3LC.MetricState).STARTED) (0, $69Zr8.pageLoadMetaMetric).onStop(()=>{
            super.stop({
                ...params,
                stopTime: params.stopTime || now
            });
        }, ()=>{
            this.cancel();
        });
        return true;
    }
    constructor(config){
        super(config);
        this.isInitial = true;
        this.config = void 0;
        this.config = config;
    }
}
$4f83d9bff0211700$export$24c8bfcd77494cc1.FMP = 'fmp';

});




parcelRegister("i3c1S", function(module, exports) {

$parcel$export(module.exports, "getWaterfallTimings", () => $82eb5b0eb983d5b4$export$9dbd6bda36500fa9);

var $hZpML = parcelRequire("hZpML");

var $3YpC9 = parcelRequire("3YpC9");

var $6VdZc = parcelRequire("6VdZc");
// We preload a bunch of queries on mousedown. This is actually before transition happens.
// At the moment when queries were sent we don't know the next route yet.
// So we need to look back a bit see if we can find any queries that were sent before.
const $82eb5b0eb983d5b4$var$LOOK_BEHIND_MS = 500;
function $82eb5b0eb983d5b4$export$9dbd6bda36500fa9(expectedPageSegments) {
    // Create list of timings for every segment that indicate actual start and end time for it.
    // This is useful for displaying page loading sequence as a waterfall, while tracking every
    // segment from page load start. Waterfall timings are prefixed with `wf/`.
    const markers = expectedPageSegments.map((segment)=>({
            key: `wf/react/${segment.key}`,
            endMark: `${0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_END}:${segment.key}`,
            startMark: `${0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_START}:${segment.key}`
        }));
    let measures;
    if ((0, $6VdZc.isInitial)()) measures = Object.values((0, $hZpML.WATERFALL_INITIAL_MEASURES));
    else {
        measures = (0, $hZpML.WaterfallMeasures).getMeasureKeys((0, $6VdZc.browserMetricsState).pageLoadStartTimestamp - $82eb5b0eb983d5b4$var$LOOK_BEHIND_MS).filter((key)=>key.startsWith('wf/client'));
        (0, $hZpML.WaterfallMeasures).clearMeasures();
    }
    measures.forEach((key)=>{
        markers.push({
            key: key,
            startMark: `${key}.start`,
            endMark: `${key}.end`
        });
    });
    return markers;
}

});
parcelRegister("3YpC9", function(module, exports) {

$parcel$export(module.exports, "PAGE_SEGMENT_MARK_PREFIX_START", () => $4dbe182ee19642b3$export$f59b3ea823fcdb3d);
$parcel$export(module.exports, "PAGE_SEGMENT_MARK_PREFIX_END", () => $4dbe182ee19642b3$export$a217b163593f51a);
const $4dbe182ee19642b3$export$f59b3ea823fcdb3d = 'segment-start';
const $4dbe182ee19642b3$export$a217b163593f51a = 'segment-end';

});



parcelRegister("1UCmC", function(module, exports) {

$parcel$export(module.exports, "ADMIN_ANNOUNCEMENT_BANNER_SETTING_PAGE_LOAD_KEY", () => $00aca2e58bbddd9e$export$9ee3c9e81070f140);
$parcel$export(module.exports, "ADVANCED_SEARCH_LOAD_KEY", () => $00aca2e58bbddd9e$export$162462d8f302c50a);
$parcel$export(module.exports, "UNIFIED_SEARCH_LOAD_KEY", () => $00aca2e58bbddd9e$export$17e011598d6a739d);
$parcel$export(module.exports, "CONFLUENCE_HOME_LOAD_KEY", () => $00aca2e58bbddd9e$export$a88513891a2ab6b7);
$parcel$export(module.exports, "CONTENT_HISTORY_LOAD_KEY", () => $00aca2e58bbddd9e$export$5946c48030569b81);
$parcel$export(module.exports, "EDIT_PAGE_LOAD_KEY", () => $00aca2e58bbddd9e$export$1eefb862c6c6ce00);
$parcel$export(module.exports, "EDIT_TEMPLATE_LOAD_KEY", () => $00aca2e58bbddd9e$export$e164999ba8681ff6);
$parcel$export(module.exports, "EDIT_TEMPLATE_OLD_LOAD_KEY", () => $00aca2e58bbddd9e$export$6cdf3f4614ddd679);
$parcel$export(module.exports, "EMBEDDED_VIEW_PAGE_LOAD_KEY", () => $00aca2e58bbddd9e$export$8faa34d8ba45e128);
$parcel$export(module.exports, "EMBEDDED_EDIT_PAGE_LOAD_KEY", () => $00aca2e58bbddd9e$export$3fb3338cf2b36704);
$parcel$export(module.exports, "GLOBAL_PERMISSIONS_PAGE_LOAD_KEY", () => $00aca2e58bbddd9e$export$779fbc1a16a8cb5d);
$parcel$export(module.exports, "INACCESSIBLE_PAGE_LOAD_KEY", () => $00aca2e58bbddd9e$export$9d8c586f3355f180);
$parcel$export(module.exports, "NOT_FOUND_LOAD_KEY", () => $00aca2e58bbddd9e$export$a0c73183bde575ec);
$parcel$export(module.exports, "SPACE_DIRECTORY_LOAD_KEY", () => $00aca2e58bbddd9e$export$6d480c75094dbd7f);
$parcel$export(module.exports, "SPACE_OVERVIEW_LOAD_KEY", () => $00aca2e58bbddd9e$export$8d0f9920174f22b4);
$parcel$export(module.exports, "SPACE_PAGES_LOAD_KEY", () => $00aca2e58bbddd9e$export$228f2841a225e5ad);
$parcel$export(module.exports, "TASKS_HOME_LOAD_KEY", () => $00aca2e58bbddd9e$export$fe4f0edc4d6532a8);
$parcel$export(module.exports, "SPACE_MANAGER_LOAD_KEY", () => $00aca2e58bbddd9e$export$bdc26b2b517231a);
$parcel$export(module.exports, "TEMPLATE_GALLERY_LOAD_KEY", () => $00aca2e58bbddd9e$export$b6d237d1e8f12e5d);
$parcel$export(module.exports, "VIEW_PAGE_LOAD_KEY", () => $00aca2e58bbddd9e$export$a715ad00b824ec3f);
$parcel$export(module.exports, "EMBEDDED_MARKETPLACE_LOAD_KEY", () => $00aca2e58bbddd9e$export$132f38e0c19c02b6);
$parcel$export(module.exports, "CREATE_CONTENT_LOAD_KEY", () => $00aca2e58bbddd9e$export$d2dddf4422ad7ae8);
$parcel$export(module.exports, "PUBLIC_LINK_SHARED_PAGE_LOAD_KEY", () => $00aca2e58bbddd9e$export$9c7a9f4f853f6fba);
$parcel$export(module.exports, "PUBLIC_LINK_SITE_SETTING_PAGE_LOAD_KEY", () => $00aca2e58bbddd9e$export$643b9c181748da38);
$parcel$export(module.exports, "PUBLIC_LINKS_SPACE_SETTINGS_PAGE_LOAD_KEY", () => $00aca2e58bbddd9e$export$4716363caa82a23b);
$parcel$export(module.exports, "WHITEBOARD_VIEW_PAGE_KEY", () => $00aca2e58bbddd9e$export$75726af5c0ee9402);
$parcel$export(module.exports, "DATABASE_VIEW_PAGE_KEY", () => $00aca2e58bbddd9e$export$afe76b61b3f9aaa8);
$parcel$export(module.exports, "EMBED_VIEW_PAGE_LOAD_KEY", () => $00aca2e58bbddd9e$export$dd63a13fc6c1ba34);
$parcel$export(module.exports, "LIVE_PAGE_LOAD_KEY", () => $00aca2e58bbddd9e$export$16aeb03ec0c24b89);
$parcel$export(module.exports, "LIVE_PAGE_REACT_UFO_LOAD_KEY", () => $00aca2e58bbddd9e$export$ce4e0f6f3d614d45);
$parcel$export(module.exports, "TEAM_CALENDARS_LOAD_KEY", () => $00aca2e58bbddd9e$export$ecea02b4eaa314f3);
$parcel$export(module.exports, "ADMIN_TEAM_CALENDARS_LOAD_KEY", () => $00aca2e58bbddd9e$export$726cbfa087a55101);
$parcel$export(module.exports, "ADMIN_GENERAL_CONFIGURATION_LOAD_KEY", () => $00aca2e58bbddd9e$export$2f245ed7ebaea89);
$parcel$export(module.exports, "ADMIN_CONFIGURE_CODE_MACRO_LOAD_KEY", () => $00aca2e58bbddd9e$export$2af60fefae96902b);
$parcel$export(module.exports, "ADMIN_DEFAULT_SPACE_LOGO_CONFIG_LOAD_KEY", () => $00aca2e58bbddd9e$export$fbea00ed02ef2502);
$parcel$export(module.exports, "ADMIN_HEADER_AND_FOOTER_LOAD_KEY", () => $00aca2e58bbddd9e$export$6e9c07174668ae36);
$parcel$export(module.exports, "ADMIN_SECURITY_CONFIGURATION_LOAD_KEY", () => $00aca2e58bbddd9e$export$51fdddeccf175d74);
$parcel$export(module.exports, "ADMIN_TEMPLATES_AND_BLUEPRINTS_LOAD_KEY", () => $00aca2e58bbddd9e$export$2d0370cc7d14b72e);
$parcel$export(module.exports, "ADMIN_IMPORT_SPACES_LOAD_KEY", () => $00aca2e58bbddd9e$export$a8d02dbd84c83dd);
$parcel$export(module.exports, "ADMIN_TRASHED_SPACES_LOAD_KEY", () => $00aca2e58bbddd9e$export$1d91ea2ef976728a);
$parcel$export(module.exports, "ADMIN_APPLICATION_NAVIGATOR_KEY", () => $00aca2e58bbddd9e$export$a13bfc71dc6b7924);
$parcel$export(module.exports, "ADMIN_THEMES_LOAD_KEY", () => $00aca2e58bbddd9e$export$3ba6335cd90d2e59);
$parcel$export(module.exports, "ADMIN_JIRA_MACRO_REPAIR_LOAD_KEY", () => $00aca2e58bbddd9e$export$cb4b6b707a32ee92);
$parcel$export(module.exports, "ADMIN_PDF_EXPORT_LOAD_KEY", () => $00aca2e58bbddd9e$export$5cb6689cb672a5c0);
$parcel$export(module.exports, "ADMIN_MACRO_USAGE_LOAD_KEY", () => $00aca2e58bbddd9e$export$fff7d33fb1514c44);
$parcel$export(module.exports, "ADMIN_USER_ACCESS_KEY", () => $00aca2e58bbddd9e$export$d4aa60a3ffc18652);
$parcel$export(module.exports, "PAGE_ANALYTICS_LOAD_KEY", () => $00aca2e58bbddd9e$export$52c0c13179848b50);
$parcel$export(module.exports, "SPACE_ANALYTICS_PAGE_LOAD_KEY", () => $00aca2e58bbddd9e$export$40dab65f060e1231);
$parcel$export(module.exports, "SITE_ANALYTICS_LOAD_KEY", () => $00aca2e58bbddd9e$export$b682ed6d6fa429fb);
$parcel$export(module.exports, "SPACE_DETAILS_LOAD_KEY", () => $00aca2e58bbddd9e$export$93cf1e51c6a6b6b1);
$parcel$export(module.exports, "PDF_EXPORT_ROUTE_LOAD_KEY", () => $00aca2e58bbddd9e$export$2633c6986b98b723);
const $00aca2e58bbddd9e$export$9ee3c9e81070f140 = 'admin-announcement-banner-setting-page';
const $00aca2e58bbddd9e$export$162462d8f302c50a = 'advanced-search';
const $00aca2e58bbddd9e$export$17e011598d6a739d = 'unified-search';
const $00aca2e58bbddd9e$export$a88513891a2ab6b7 = 'confluence-home';
const $00aca2e58bbddd9e$export$5946c48030569b81 = 'content-history';
const $00aca2e58bbddd9e$export$1eefb862c6c6ce00 = 'edit-page';
const $00aca2e58bbddd9e$export$e164999ba8681ff6 = 'edit-template';
const $00aca2e58bbddd9e$export$6cdf3f4614ddd679 = 'edit-template-old';
const $00aca2e58bbddd9e$export$8faa34d8ba45e128 = 'embedded-view-page';
const $00aca2e58bbddd9e$export$3fb3338cf2b36704 = 'embedded-edit-page';
const $00aca2e58bbddd9e$export$779fbc1a16a8cb5d = 'global-permissions';
const $00aca2e58bbddd9e$export$9d8c586f3355f180 = 'inaccessible-page';
const $00aca2e58bbddd9e$export$a0c73183bde575ec = 'not-found';
const $00aca2e58bbddd9e$export$6d480c75094dbd7f = 'space-directory';
const $00aca2e58bbddd9e$export$8d0f9920174f22b4 = 'space-overview';
const $00aca2e58bbddd9e$export$228f2841a225e5ad = 'space-pages';
const $00aca2e58bbddd9e$export$fe4f0edc4d6532a8 = 'tasks-home';
const $00aca2e58bbddd9e$export$bdc26b2b517231a = 'space-manager';
const $00aca2e58bbddd9e$export$b6d237d1e8f12e5d = 'template-gallery';
const $00aca2e58bbddd9e$export$a715ad00b824ec3f = 'view-page';
const $00aca2e58bbddd9e$export$132f38e0c19c02b6 = 'embedded-marketplace';
const $00aca2e58bbddd9e$export$d2dddf4422ad7ae8 = 'create-content';
const $00aca2e58bbddd9e$export$9c7a9f4f853f6fba = 'public-link-shared-page';
const $00aca2e58bbddd9e$export$643b9c181748da38 = 'public-link-site-setting-page';
const $00aca2e58bbddd9e$export$4716363caa82a23b = 'public-links-space-settings-page';
const $00aca2e58bbddd9e$export$75726af5c0ee9402 = 'whiteboard-view-page';
const $00aca2e58bbddd9e$export$afe76b61b3f9aaa8 = 'database-view-page';
const $00aca2e58bbddd9e$export$dd63a13fc6c1ba34 = 'embed-view-page';
const $00aca2e58bbddd9e$export$16aeb03ec0c24b89 = 'live-page';
const $00aca2e58bbddd9e$export$ce4e0f6f3d614d45 = 'live-edit';
const $00aca2e58bbddd9e$export$ecea02b4eaa314f3 = 'team-calendars';
const $00aca2e58bbddd9e$export$726cbfa087a55101 = 'admin-team-calendars';
const $00aca2e58bbddd9e$export$2f245ed7ebaea89 = 'admin-general-configuration';
const $00aca2e58bbddd9e$export$2af60fefae96902b = 'admin-configure-code-macro';
const $00aca2e58bbddd9e$export$fbea00ed02ef2502 = 'admin-default-space-logo-config';
const $00aca2e58bbddd9e$export$6e9c07174668ae36 = 'admin-header-and-footer';
const $00aca2e58bbddd9e$export$51fdddeccf175d74 = 'admin-security-configuration';
const $00aca2e58bbddd9e$export$2d0370cc7d14b72e = 'admin-templates-and-blueprints';
const $00aca2e58bbddd9e$export$a8d02dbd84c83dd = 'admin-import-spaces';
const $00aca2e58bbddd9e$export$1d91ea2ef976728a = 'admin-trashed-spaces';
const $00aca2e58bbddd9e$export$a13bfc71dc6b7924 = 'admin-application-navigator';
const $00aca2e58bbddd9e$export$3ba6335cd90d2e59 = 'admin-themes';
const $00aca2e58bbddd9e$export$cb4b6b707a32ee92 = 'admin-jira-macro-repair';
const $00aca2e58bbddd9e$export$5cb6689cb672a5c0 = 'admin-pdf-export';
const $00aca2e58bbddd9e$export$fff7d33fb1514c44 = 'admin-macro-usage';
const $00aca2e58bbddd9e$export$d4aa60a3ffc18652 = 'admin-user-access';
const $00aca2e58bbddd9e$export$52c0c13179848b50 = 'CONTENT_ANALYTICS';
const $00aca2e58bbddd9e$export$40dab65f060e1231 = 'SPACE_ANALYTICS';
const $00aca2e58bbddd9e$export$b682ed6d6fa429fb = 'INSTANCE_ANALYTICS';
const $00aca2e58bbddd9e$export$93cf1e51c6a6b6b1 = 'space-details';
const $00aca2e58bbddd9e$export$2633c6986b98b723 = 'pdf-export-route';

});

parcelRegister("7fw2E", function(module, exports) {

$parcel$export(module.exports, "markBrowserMetricEnd", () => $4bc3b2e76c18c48c$export$94f26401757ac8e7);

var $6VdZc = parcelRequire("6VdZc");
const $4bc3b2e76c18c48c$export$94f26401757ac8e7 = (metric)=>{
    let params;
    try {
        if ((0, $6VdZc.isInitial)()) {
            if (metric) {
                const data = metric.getData?.();
                const start = data?.start || 0;
                const stop = data?.stop || 0;
                params = [
                    {
                        duration: stop - start,
                        end: 'browser-metric.end'
                    }
                ];
            } else params = [
                undefined,
                'browser-metric.end'
            ];
        } else params = [
            'browser-metric.start',
            'browser-metric.end'
        ];
        performance.mark('browser-metric.end');
        performance.measure('browser-metric:tti', ...params);
    } catch (e) {
    // Suppress error when performance API failed.
    // Note: in MicrosoftEdge version 18 and prior, performance.measure(name, startMark, endMark) API will throw SyntaxError if startMark is undefined.
    // That's why wrap with try catch statement.
    }
};

});

parcelRegister("8w1c1", function(module, exports) {

$parcel$export(module.exports, "APP_NAVIGATION_METRIC", () => $73e19354f9924125$export$d9a22aa9387ada7a);

var $lSOAM = parcelRequire("lSOAM");

var $jX1qB = parcelRequire("jX1qB");
const $73e19354f9924125$export$d9a22aa9387ada7a = (0, $lSOAM.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.APP_NAVIGATION_SEGMENT_KEY),
    ssr: Boolean(window.__SSR_RENDERED__) ? {
        doneAsFmp: true
    } : undefined
});

});

parcelRegister("1q7H7", function(module, exports) {

$parcel$export(module.exports, "PAGE_TREE_METRIC", () => $108e3019fffb7b94$export$6e28125ef9389dc6);
$parcel$export(module.exports, "MOVE_PAGE_DIALOG_INTERACTION_METRIC", () => $108e3019fffb7b94$export$45b21bbf8961b519);

var $lSOAM = parcelRequire("lSOAM");
var $jIOyV = parcelRequire("jIOyV");
var $jX1qB = parcelRequire("jX1qB");
const $108e3019fffb7b94$export$6e28125ef9389dc6 = (0, $lSOAM.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.PAGE_TREE_SEGMENT_KEY),
    ssr: Boolean(window.__SSR_RENDERED__) ? {
        doneAsFmp: true
    } : undefined
});
const $108e3019fffb7b94$export$45b21bbf8961b519 = (0, $lSOAM.createInteractionMetric)({
    key: (0, $jIOyV.MOVE_PAGE_DIALOG_INTERACTION)
});

});
parcelRegister("jIOyV", function(module, exports) {

$parcel$export(module.exports, "MORE_ACTIONS_DROPDOWN_INTERACTION", () => $4fa41f80373a2ebe$export$f49429c67898bd15);
$parcel$export(module.exports, "MOVE_PAGE_DIALOG_INTERACTION", () => $4fa41f80373a2ebe$export$daaf73616fe91ce9);
$parcel$export(module.exports, "CONTENT_ANALYTICS_DIALOG_INTERACTION", () => $4fa41f80373a2ebe$export$d4222bce9029f393);
$parcel$export(module.exports, "CONTENT_ANALYTICS_DIALOG_MENTIONS_TAB_INTERACTION", () => $4fa41f80373a2ebe$export$b6f3d4f73cb88d6c);
$parcel$export(module.exports, "RESTRICTIONS_DIALOG_INTERACTION", () => $4fa41f80373a2ebe$export$eb06363d6ef3b8dd);
$parcel$export(module.exports, "QUICK_SUMMARY_DIALOG_INTERACTION", () => $4fa41f80373a2ebe$export$ef2fb65c026ab7d3);
$parcel$export(module.exports, "OPEN_LOOM_RECORDER_SDK_INTERACTION", () => $4fa41f80373a2ebe$export$8122cf0ca2968a7b);
$parcel$export(module.exports, "INITIALIZE_LOOM_RECORDER_SDK_INTERACTION", () => $4fa41f80373a2ebe$export$ea9696a28a6fbc61);
$parcel$export(module.exports, "COMMENTS_SUMMARY_COMPONENT_INTERACTION", () => $4fa41f80373a2ebe$export$e561726b92a6162d);
$parcel$export(module.exports, "CREATE_SPACE_DRAWER_INTERACTION", () => $4fa41f80373a2ebe$export$e348981755bdab67);
$parcel$export(module.exports, "VIEW_AI_PRESENTATION_INTERACTION", () => $4fa41f80373a2ebe$export$af1eb8557193d022);
$parcel$export(module.exports, "AI_CONTENT_CATCHUP_INTERACTION", () => $4fa41f80373a2ebe$export$7f72b8ffbbbfef58);
// "confluence.fe.interaction.XXX"
const $4fa41f80373a2ebe$export$f49429c67898bd15 = 'more-actions-dropdown';
const $4fa41f80373a2ebe$export$daaf73616fe91ce9 = 'move-page-dialog';
const $4fa41f80373a2ebe$export$d4222bce9029f393 = 'content-analytics-dialog';
const $4fa41f80373a2ebe$export$b6f3d4f73cb88d6c = 'content-analytics-dialog-mentions-tab';
const $4fa41f80373a2ebe$export$eb06363d6ef3b8dd = 'restrictions-dialog';
const $4fa41f80373a2ebe$export$ef2fb65c026ab7d3 = 'quick-summary-dialog';
const $4fa41f80373a2ebe$export$8122cf0ca2968a7b = 'open-loom-recorder-sdk';
const $4fa41f80373a2ebe$export$ea9696a28a6fbc61 = 'initialize-loom-recorder-sdk';
const $4fa41f80373a2ebe$export$e561726b92a6162d = 'comments_summary_component';
const $4fa41f80373a2ebe$export$e348981755bdab67 = 'create-space-drawer';
const $4fa41f80373a2ebe$export$af1eb8557193d022 = 'ai-presentation-modal';
const $4fa41f80373a2ebe$export$7f72b8ffbbbfef58 = 'ai-content-catchup';

});


parcelRegister("14SPd", function(module, exports) {

$parcel$export(module.exports, "RESTRICTIONS_BUTTON_METRIC", () => $8ab24ab9418ac89d$export$34cc51d2a4e5cf67);
$parcel$export(module.exports, "RESTRICTIONS_DIALOG_METRIC", () => $8ab24ab9418ac89d$export$2ba38536ff91e2a7);

var $lSOAM = parcelRequire("lSOAM");
var $jX1qB = parcelRequire("jX1qB");
var $jIOyV = parcelRequire("jIOyV");
const $8ab24ab9418ac89d$export$34cc51d2a4e5cf67 = (0, $lSOAM.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.RESTRICTIONS_BUTTON_SEGMENT_KEY),
    timings: [
        {
            key: 'fmp',
            endMark: 'fmp'
        },
        {
            key: 'tti',
            endMark: 'tti'
        }
    ]
});
const $8ab24ab9418ac89d$export$2ba38536ff91e2a7 = (0, $lSOAM.createInteractionMetric)({
    key: (0, $jIOyV.RESTRICTIONS_DIALOG_INTERACTION)
});

});

parcelRegister("aWrnw", function(module, exports) {

$parcel$export(module.exports, "SPACE_NAVIGATION_METRIC", () => $d4615ab6ca7803f7$export$b9931e60e47a0122);
$parcel$export(module.exports, "SPACE_NAVIGATION_QUERY_METRIC", () => $d4615ab6ca7803f7$export$c2270f6b1f217fda);
$parcel$export(module.exports, "SPACE_APPS_METRIC", () => $d4615ab6ca7803f7$export$618f453a5683e37b);

var $lSOAM = parcelRequire("lSOAM");
var $jX1qB = parcelRequire("jX1qB");
var $fd6g2 = parcelRequire("fd6g2");

var $1Hqbt = parcelRequire("1Hqbt");
const $d4615ab6ca7803f7$export$b9931e60e47a0122 = (0, $lSOAM.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.SPACE_NAVIGATION_SEGMENT_KEY),
    ssr: (0, $1Hqbt.ssrConfig)()
});
const $d4615ab6ca7803f7$export$c2270f6b1f217fda = (0, $lSOAM.createCustomMetric)({
    key: (0, $fd6g2.SPACE_NAVIGATION_QUERY_CUSTOM_KEY)
});
const $d4615ab6ca7803f7$export$618f453a5683e37b = (0, $lSOAM.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.SPACE_APPS_SEGMENT_KEY),
    ssr: (0, $1Hqbt.ssrConfig)()
});

});
parcelRegister("fd6g2", function(module, exports) {

$parcel$export(module.exports, "MENTIONS_QUERY_CUSTOM_KEY", () => $88f9a74d7687653d$export$3fe4a04f712fdf3b);
$parcel$export(module.exports, "PROFILE_CARD_QUERY_CUSTOM_KEY", () => $88f9a74d7687653d$export$18a3d3c084ff47d0);
$parcel$export(module.exports, "SPACE_NAVIGATION_QUERY_CUSTOM_KEY", () => $88f9a74d7687653d$export$7006cbf006c53070);
$parcel$export(module.exports, "LEGACY_EXTENSION_LOADING_CUSTOM_KEY", () => $88f9a74d7687653d$export$95463e4d15a0dca9);
$parcel$export(module.exports, "FABRIC_PUBLISH_PAGE_KEY", () => $88f9a74d7687653d$export$5a66bfdc2ac06329);
$parcel$export(module.exports, "TIME_TO_APP_IDLE_KEY", () => $88f9a74d7687653d$export$96dfe3e664538004);
$parcel$export(module.exports, "TEAM_CALENDARS_EVENT_FETCH_KEY", () => $88f9a74d7687653d$export$d0eb1faf5fa0dbc7);
$parcel$export(module.exports, "TEAM_CALENDARS_SUBCALS_FETCH_KEY", () => $88f9a74d7687653d$export$ec119fee4dbc7f75);
$parcel$export(module.exports, "AI_SNIPPET_HOVER_CARD_SEGMENT_KEY", () => $88f9a74d7687653d$export$5e0f3443b5224f1d);
$parcel$export(module.exports, "TEAM_CALENDARS_JIRA_PROJECTS_FETCH_KEY", () => $88f9a74d7687653d$export$693c7d831f137ed3);
// "confluence.fe.custom.XXX"
const $88f9a74d7687653d$export$3fe4a04f712fdf3b = 'mentions-query';
const $88f9a74d7687653d$export$18a3d3c084ff47d0 = 'profile-card-query';
const $88f9a74d7687653d$export$7006cbf006c53070 = 'space-navigation-query';
const $88f9a74d7687653d$export$95463e4d15a0dca9 = 'legacy-extension-loading';
const $88f9a74d7687653d$export$5a66bfdc2ac06329 = 'fabric-publish-page';
const $88f9a74d7687653d$export$96dfe3e664538004 = 'time-to-app-idle';
const $88f9a74d7687653d$export$18a3e97ff841447b = 'share-notif-from-restrictions';
const $88f9a74d7687653d$export$d0eb1faf5fa0dbc7 = 'tc-events-fetch';
const $88f9a74d7687653d$export$ec119fee4dbc7f75 = 'tc-subcals-fetch';
const $88f9a74d7687653d$export$5e0f3443b5224f1d = 'ai-snippet-hover-card';
const $88f9a74d7687653d$export$693c7d831f137ed3 = 'tc-jira-projects-fetch';

});

parcelRegister("1Hqbt", function(module, exports) {

$parcel$export(module.exports, "ssrConfig", () => $a75b16828791e7fd$export$ea92d4e542ec02b3);
const $a75b16828791e7fd$export$ea92d4e542ec02b3 = ()=>Boolean(window.__SSR_RENDERED__) ? {
        doneAsFmp: true
    } : undefined;

});


parcelRegister("3VbV8", function(module, exports) {

$parcel$export(module.exports, "FABRIC_PUBLISH_PAGE_METRIC", () => $3fce579e2620525b$export$dfd790981c086398);
$parcel$export(module.exports, "EDIT_PAGE_LOAD", () => $3fce579e2620525b$export$5ac2615d36b4500c);
$parcel$export(module.exports, "EDITOR_METRIC", () => $3fce579e2620525b$export$c5146b9e6a61ee5f);
$parcel$export(module.exports, "EMBEDDED_EDIT_PAGE_LOAD", () => $3fce579e2620525b$export$f9b776b1c66e5f0e);

var $lSOAM = parcelRequire("lSOAM");
var $1UCmC = parcelRequire("1UCmC");
var $jX1qB = parcelRequire("jX1qB");
var $fd6g2 = parcelRequire("fd6g2");
const $3fce579e2620525b$export$dfd790981c086398 = (0, $lSOAM.createCustomMetric)({
    key: (0, $fd6g2.FABRIC_PUBLISH_PAGE_KEY),
    histogram: {
        duration: '1000_2000_3000_4000_5000_6000_7000_8000_9000'
    }
});
const $3fce579e2620525b$export$5ac2615d36b4500c = (0, $lSOAM.createPageLoadMetric)({
    key: (0, $1UCmC.EDIT_PAGE_LOAD_KEY),
    timings: [
        {
            key: 'onBeforeEditor',
            endMark: 'onBeforeEditor'
        },
        {
            key: 'editorRendered',
            startMark: 'onBeforeEditor'
        }
    ]
});
const $3fce579e2620525b$export$c5146b9e6a61ee5f = (0, $lSOAM.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.EDITOR_SEGMENT_KEY)
});
const $3fce579e2620525b$export$af294f5bd71dc2d = (0, $lSOAM.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.NCS_CONNECTED_FMP_KEY)
});
const $3fce579e2620525b$export$f9b776b1c66e5f0e = (0, $lSOAM.createPageLoadMetric)({
    key: (0, $1UCmC.EMBEDDED_EDIT_PAGE_LOAD_KEY)
});

});

parcelRegister("kmyZQ", function(module, exports) {

$parcel$export(module.exports, "ProgressBarContainer", () => $766713eeaff568b4$export$91fd6e064cf0bcf3);
// We have deprecated unstated. Please use react-sweet-state instead
// eslint-disable-next-line no-restricted-imports

var $ipPpS = parcelRequire("ipPpS");


var $9wGTI = parcelRequire("9wGTI");

var $1ps47 = parcelRequire("1ps47");
class $766713eeaff568b4$export$91fd6e064cf0bcf3 extends (0, $ipPpS.Container) {
    getInitialStatus(state) {
        if (state) return state.status;
        // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
        const isSSR = (0, window.__SSR_RENDERED__);
        if (isSSR && (0, $9wGTI.fg)('confluence_perceived_perf_hide_loading_bar')) {
            // window.__SSR_IS_LIVE_PAGE__ only works in hydration after SSR, so need to use ssr-inputs when its in SSR mode to get the live page data.
            // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
            const isLivePageSSR = (0, window.__SSR_IS_LIVE_PAGE__);
            if (isLivePageSSR) return 'RESET';
        }
        return isSSR ? 'SSR' : 'RESET';
    }
    constructor(state){
        super();
        this.exitAnimationTimer = void 0;
        this.delayedAnimationTimer = void 0;
        this.timeoutTimer = void 0;
        /**
     * There are race conditions where we try to start too soon after resetting,
     * with the result being that state is not yet updated and the start fails.
     * This class property is a hack used to circumvent that behavior.
     */ this.recentlyReset = false;
        /**
     * isStarting is used for handling a race condition.
     * When a page is cached, start() and finish() are fired simultaneously.
     * In start() function, setState({ status: "START" }) is async,
     * so when finish() is invoked, status haven't been set to "START" yet.
     */ this.isStarting = false;
        this.isStopping = false;
        this.prevMatch = null;
        this.isRunning = ()=>(this.state.status === 'START' || this.isStarting) && !this.isStopping;
        this.isDelayed = ()=>this.state.status === 'DELAYED';
        this.hasStarted = ()=>this.isRunning() || this.isDelayed();
        this.isStartable = ()=>this.state.status === 'RESET' || this.state.status === 'SSR' || this.recentlyReset;
        this.getStatus = ()=>{
            return this.state.status;
        };
        this.getDuration = ()=>{
            return this.state.duration || (0, $1ps47.DEFAULT_LOADING_DURATION);
        };
        /**
     * The progress bar start to move.
     */ this.start = (duration = (0, $1ps47.DEFAULT_LOADING_DURATION), timeoutDuration = (0, $1ps47.TIMEOUT_TIMER))=>{
            if (!this.isStartable()) return Promise.resolve();
            this.recentlyReset = false;
            this.isStarting = true;
            /**
       * If the progress bar has started, and haven't received a finish signal within ${DEFAULT_LOADING_DURATION}ms,
       * render shimmer and linear-gradient effect.
       */ this.delayedAnimationTimer = setTimeout(()=>{
                if (!this.isRunning()) return;
                this.setState({
                    status: 'DELAYED'
                });
            }, duration);
            /**
       * If the progress bar has started, and haven't received a finish signal within ${TIMEOUT_TIMER}ms,
       * hide the progress bar, and reset the data.
       */ this.timeoutTimer = setTimeout(()=>{
                if (!this.isDelayed()) return;
                this.reset();
            }, timeoutDuration);
            return this.setState({
                status: 'START',
                duration: duration
            }, ()=>{
                this.isStarting = false;
            });
        };
        /**
     * Trigger the progress bar to move to the end quickly.
     */ this.finish = ()=>{
            if (!(this.isRunning() || this.isDelayed())) return;
            this.isStopping = true;
            let promise;
            if (this.isDelayed()) promise = this.reset();
            else {
                if ((0, $9wGTI.fg)('confluence_progress-bar-bugfix')) this.isStarting = false;
                promise = this.setState({
                    status: 'FINISH'
                }, ()=>{
                    this.isStopping = false;
                });
            }
            this.exitAnimationTimer = setTimeout(()=>{
                this.reset();
            }, (0, $1ps47.POST_FINISHED_IDLE_DURATION));
            return promise;
        };
        /**
     * Hide the progress bar and reset the data.
     */ this.reset = ()=>{
            clearTimeout(this.exitAnimationTimer);
            clearTimeout(this.delayedAnimationTimer);
            clearTimeout(this.timeoutTimer);
            const promise = this.setState({
                status: 'RESET'
            });
            this.recentlyReset = true;
            this.isStopping = false;
            return promise;
        };
        this.state = {
            status: this.getInitialStatus(state),
            duration: state && state.duration || (0, $1ps47.DEFAULT_LOADING_DURATION)
        };
    }
}

});
parcelRegister("1ps47", function(module, exports) {

$parcel$export(module.exports, "PROGRESS_STYLE_ID", () => $91d046db84f1ff20$export$472f7f1dd63f0a09);
$parcel$export(module.exports, "PROGRESS_BAR_ID", () => $91d046db84f1ff20$export$3acd3aa8281b07d8);
$parcel$export(module.exports, "DEFAULT_LOADING_BAR_COLOR", () => $91d046db84f1ff20$export$53d51cc6d57e44da);
$parcel$export(module.exports, "EXIT_ANIMATION_SPEED", () => $91d046db84f1ff20$export$5412169de0facc6c);
$parcel$export(module.exports, "DEFAULT_LOADING_DURATION", () => $91d046db84f1ff20$export$899393f3e23f724b);
$parcel$export(module.exports, "TIMEOUT_TIMER", () => $91d046db84f1ff20$export$7868b416d8929c55);
$parcel$export(module.exports, "POST_FINISHED_IDLE_DURATION", () => $91d046db84f1ff20$export$55cff6338bbd9ca8);
const $91d046db84f1ff20$export$472f7f1dd63f0a09 = 'progressStyles';
const $91d046db84f1ff20$export$3acd3aa8281b07d8 = 'global-progress-bar';
const $91d046db84f1ff20$export$53d51cc6d57e44da = "var(--ds-background-brand-bold, #0C66E4)";
const $91d046db84f1ff20$export$5412169de0facc6c = 300;
const $91d046db84f1ff20$export$899393f3e23f724b = 6000;
const $91d046db84f1ff20$export$7868b416d8929c55 = 20000;
const $91d046db84f1ff20$export$55cff6338bbd9ca8 = $91d046db84f1ff20$export$5412169de0facc6c + 50;

});


parcelRegister("hfPJk", function(module, exports) {

$parcel$export(module.exports, "useUnifiedShareDialogEligible", () => $4c837cd68f9ce4c0$export$ec1a39480eeb12ae);

var $d9tcB = parcelRequire("d9tcB");
var $bQm3c = parcelRequire("bQm3c");

var $euL71 = parcelRequire("euL71");

var $6mKj3 = parcelRequire("6mKj3");
const $4c837cd68f9ce4c0$export$ec1a39480eeb12ae = (skipExposure = false)=>{
    const { edition: edition, isLoggedIn: isLoggedIn, accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    const isLicensed = [
        (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS,
        (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS
    ].includes(accessStatus);
    const isStandard = [
        (0, $euL71.ConfluenceEdition).STANDARD
    ].includes(edition);
    const isEligible = isLoggedIn && isLicensed && isStandard;
    return {
        isUSDExperimentEnabled: isEligible ? skipExposure ? (0, $6mKj3.expValEqualsNoExposure)('unified_share_dialog_usd_experiment', 'cohort', 'test') : (0, $6mKj3.expValEquals)('unified_share_dialog_usd_experiment', 'cohort', 'test') : false
    };
};

});



parcelRegister("ivb8S", function(module, exports) {

$parcel$export(module.exports, "deserializeState", () => $6fc4b7bb962289cc$export$7ca8667598519375);
$parcel$export(module.exports, "useSetOnboardingState", () => $6fc4b7bb962289cc$export$c5bcaee8a4aee6cf);
$parcel$export(module.exports, "useGetOnboardingState", () => $6fc4b7bb962289cc$export$d5e7611ac338ec84);
/**
 * @graphql cc
 */ 
var $d2LG0 = parcelRequire("d2LG0");

var $gwFzn = parcelRequire("gwFzn");

var $j1Ss3 = parcelRequire("j1Ss3");

var $7Sm4c = parcelRequire("7Sm4c");

var $8Lx5S = parcelRequire("8Lx5S");

var $cbOce = parcelRequire("cbOce");
const $6fc4b7bb962289cc$export$7ca8667598519375 = (data)=>{
    const state = {};
    // new graphQL call returns onboardingState array
    const { onboardingState: onboardingState } = data || {};
    // parse data and populate state accordingly
    if (onboardingState !== undefined) onboardingState.forEach(({ key: key, value: value })=>{
        // key comes back as "quickstart-state:{property}" format
        // split by ':' to get parsed {property}
        // some keys don't have a prefix, which is why we have the ||
        const parsedKey = key.split(':')[1] || key;
        if (!value) return;
        if (/(true|false)/g.test(value)) state[parsedKey] = value === 'true';
        else state[parsedKey] = value;
    });
    return state;
};
const $6fc4b7bb962289cc$export$c5bcaee8a4aee6cf = ()=>{
    const [setState, { error: error, called: called }] = (0, $j1Ss3.useMutation)((0, $d2LG0.default)`mutation onboardingStateSetOnboardingStateMutation($states:[OnboardingStateInput!]!){setOnboardingState(states:$states){key value}}`, {
        update (cache, { data: data }) {
            const states = data.setOnboardingState;
            states.forEach(({ key: key, value: value })=>{
                // writeFragment can only handle a single data item at a time
                cache.writeFragment({
                    id: `OnboardingState:${key}`,
                    fragment: (0, $d2LG0.default)`fragment myKey on OnboardingState{key value}`,
                    data: {
                        key: key,
                        value: value,
                        __typename: 'OnboardingState'
                    }
                });
            });
        },
        onError: (error)=>{
            if ((0, $cbOce.isExpectedError)(error)) (0, $7Sm4c.markErrorAsHandled)(error);
        }
    });
    const setOnboardingState = (0, $gwFzn.useCallback)((newOnboardingState)=>{
        let states;
        if (Array.isArray(newOnboardingState)) // supports batch updates
        states = newOnboardingState;
        else // backwards compability for single key-value pair
        states = [
            newOnboardingState
        ];
        setState({
            variables: {
                states: states
            },
            optimisticResponse: {
                setOnboardingState: states.map(({ key: key, value: value })=>({
                        key: key,
                        value: value,
                        __typename: 'OnboardingState'
                    }))
            }
        });
    }, [
        setState
    ]);
    return {
        setOnboardingState: setOnboardingState,
        error: error,
        called: called
    };
};
const $6fc4b7bb962289cc$export$d5e7611ac338ec84 = (key, skip = false)=>{
    const { isLicensed: isLicensed, isGuest: isGuest } = (0, $8Lx5S.useAccessStatus)();
    const isAllowed = isLicensed || isGuest;
    const skipQuery = skip || !isAllowed;
    const { data: data, error: error, loading: loading, refetch: refetch } = (0, $j1Ss3.useQuery)((0, $d2LG0.default)`query onboardingStateGetOnboardingStateQuery($key:[String]){onboardingState(key:$key){key value}}`, {
        variables: {
            key: key
        },
        skip: skipQuery
    });
    return {
        data: data,
        error: error,
        loading: loading,
        refetch: refetch
    };
};

});
parcelRegister("8Lx5S", function(module, exports) {

$parcel$export(module.exports, "useIsLicensed", () => $30f02aa82d7102bc$export$ac4f65b11c57a33b);
$parcel$export(module.exports, "useIsGuest", () => $30f02aa82d7102bc$export$f9ffae90e66d63e);
$parcel$export(module.exports, "useAccessStatus", () => $30f02aa82d7102bc$export$41f8700aabec6a40);

var $bQm3c = parcelRequire("bQm3c");

var $d9tcB = parcelRequire("d9tcB");
/**
 * Checks if the user has any licensed access (either admin or use access).
 *
 * @param {AccessStatus | null} accessStatus - The access status of the user.
 * @returns {boolean} - Returns true if the user has licensed admin or use access, otherwise false.
 * @warning ⚠️ This field is not available in the query preloader in SSR. Do not rely on it to skip preloader queries in SSR.
 */ const $30f02aa82d7102bc$var$isLicensed = (accessStatus)=>{
    return accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS || accessStatus === (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS;
};
/**
 * Checks if the user has licensed admin access.
 *
 * @param {AccessStatus | null} accessStatus - The access status of the user.
 * @returns {boolean} - Returns true if the user has licensed admin access, otherwise false.
 * @warning ⚠️ This field is not available in the query preloader in SSR. Do not rely on it to skip preloader queries in SSR.
 */ const $30f02aa82d7102bc$var$isAdmin = (accessStatus)=>{
    return accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS;
};
/**
 * Checks if the user has licensed non-admin access (use access).
 *
 * @param {AccessStatus | null} accessStatus - The access status of the user.
 * @returns {boolean} - Returns true if the user has licensed use access, otherwise false.
 * @warning ⚠️ This field is not available in the query preloader in SSR. Do not rely on it to skip preloader queries in SSR.
 */ const $30f02aa82d7102bc$var$isLicensedNonAdmin = (accessStatus)=>{
    return accessStatus === (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS;
};
/**
 * Checks if the user is a guest (external collaborator).
 *
 * @param {AccessStatus | null} accessStatus - The access status of the user.
 * @returns {boolean} - Returns true if the user is an external collaborator, otherwise false.
 * @warning ⚠️ This field is not available in the query preloader in SSR. Do not rely on it to skip preloader queries in SSR.
 */ const $30f02aa82d7102bc$var$isGuest = (accessStatus)=>{
    return accessStatus === (0, $d9tcB.AccessStatus).EXTERNAL_COLLABORATOR_ACCESS;
};
const $30f02aa82d7102bc$export$ac4f65b11c57a33b = ()=>{
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    return $30f02aa82d7102bc$var$isLicensed(accessStatus);
};
const $30f02aa82d7102bc$export$99a5e4bc80d231ca = ()=>{
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    return $30f02aa82d7102bc$var$isAdmin(accessStatus);
};
const $30f02aa82d7102bc$export$a67466804611d2db = ()=>{
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    return $30f02aa82d7102bc$var$isLicensedNonAdmin(accessStatus);
};
const $30f02aa82d7102bc$export$f9ffae90e66d63e = ()=>{
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    return $30f02aa82d7102bc$var$isGuest(accessStatus);
};
const $30f02aa82d7102bc$export$41f8700aabec6a40 = ()=>{
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    return {
        isGuest: $30f02aa82d7102bc$var$isGuest(accessStatus),
        isLicensed: $30f02aa82d7102bc$var$isLicensed(accessStatus),
        isAdmin: $30f02aa82d7102bc$var$isAdmin(accessStatus),
        isLicensedNonAdmin: $30f02aa82d7102bc$var$isLicensedNonAdmin(accessStatus)
    };
};

});

parcelRegister("cbOce", function(module, exports) {

$parcel$export(module.exports, "isExpectedError", () => $2f49c1e50cca9335$export$8715824c16ceeca0);

var $flE5X = parcelRequire("flE5X");

var $dIouf = parcelRequire("dIouf");
function $2f49c1e50cca9335$export$8715824c16ceeca0(error) {
    const isUnauthorized = error?.graphQLErrors?.[0]?.message === 'unauthorized' || (0, $dIouf.isUnauthorizedError)(error);
    return isUnauthorized || (0, $flE5X.containsNoNetworkError)(error);
}

});


parcelRegister("7aRa9", function(module, exports) {

$parcel$export(module.exports, "withFlags", () => $eb37d7497b3d263d$export$e624a3067d475d88);

var $gwFzn = parcelRequire("gwFzn");

var $ipPpS = parcelRequire("ipPpS");

var $gqqjz = parcelRequire("gqqjz");
function $eb37d7497b3d263d$export$e624a3067d475d88(InnerComponent) {
    var _WithFlags;
    return _WithFlags = class WithFlags extends (0, $gwFzn.Component) {
        render() {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ipPpS.Subscribe), {
                to: [
                    (0, $gqqjz.FlagsStateContainer)
                ]
            }, (flags)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(InnerComponent, {
                    ...this.props,
                    flags: flags
                }));
        }
    }, _WithFlags.displayName = `withFlags(${InnerComponent.displayName || InnerComponent.name})`, _WithFlags;
}

});

parcelRegister("dBcar", function(module, exports) {

$parcel$export(module.exports, "PEOPLE", () => $3c94963df51c0e13$export$f35f2899eb1390e3);
$parcel$export(module.exports, "FIRST_SPACE_SELECTED", () => $3c94963df51c0e13$export$1f72e9a162b3795b);
$parcel$export(module.exports, "HELP", () => $3c94963df51c0e13$export$da223e550b96c9d6);
$parcel$export(module.exports, "ONBOARDING_INTENTS", () => $3c94963df51c0e13$export$ffb6b379ff35f9e);
$parcel$export(module.exports, "ONBOARDING_INTENT_EXPERIENCES", () => $3c94963df51c0e13$export$49ac0bbeb4be0a06);
$parcel$export(module.exports, "ONBOARDING_REVERSE_TRIAL", () => $3c94963df51c0e13$export$6167e5b70dfd11d9);
$parcel$export(module.exports, "TEMPLATES_COLLECTION", () => $3c94963df51c0e13$export$49c044e5e3ccc2af);
$parcel$export(module.exports, "PERSISTENT_INVITE", () => $3c94963df51c0e13$export$305c55ea55928edf);
$parcel$export(module.exports, "IS_NAV_4_GLOBAL_SPOTLIGHT_DISMISSED", () => $3c94963df51c0e13$export$b99b309b286adebc);
$parcel$export(module.exports, "IS_NAV_4_SPACE_TOUR_DISMISSED", () => $3c94963df51c0e13$export$20b0548cf5859d6);
$parcel$export(module.exports, "WHATS_NEW_IN_CONFLUENCE", () => $3c94963df51c0e13$export$7ed75560092630f6);
$parcel$export(module.exports, "MODERNIZE_CONFLUENCE_IPM_MODAL", () => $3c94963df51c0e13$export$cba7fd986c721ece);
$parcel$export(module.exports, "NTH_USER_SETUP_CONTENT_TYPE", () => $3c94963df51c0e13$export$d1ec748fb682ca97);
$parcel$export(module.exports, "PROMPT_WHITEBOARD_COMPETITOR_LINK_DISMISSED", () => $3c94963df51c0e13$export$1a3a43cef0acd011);
$parcel$export(module.exports, "ONBOARDING_EXPERIENCES", () => $3c94963df51c0e13$export$bfeb2da96277b623);
$parcel$export(module.exports, "COMPLETE", () => $3c94963df51c0e13$export$1660a2d7c2fff354);
const $3c94963df51c0e13$export$4ddca8f5712d2331 = 'onboarding-state:';
const $3c94963df51c0e13$export$f35f2899eb1390e3 = 'peopleNudge';
const $3c94963df51c0e13$export$532485ca1547f1aa = 'legacy';
const $3c94963df51c0e13$export$31c8494ea74d2536 = 'introWorkflow';
const $3c94963df51c0e13$export$1f72e9a162b3795b = 'firstSpaceSelected';
const $3c94963df51c0e13$export$6315bee451a9fcc6 = 'teamSpaceCreated';
const $3c94963df51c0e13$export$da223e550b96c9d6 = 'help';
const $3c94963df51c0e13$export$ffb6b379ff35f9e = 'onboardingIntents';
const $3c94963df51c0e13$export$d3276a0d758ffd2b = 'isFoundingAdmin';
const $3c94963df51c0e13$export$756b1a5a6b2488c3 = 'isSampleContentV2SpotlightVisible';
const $3c94963df51c0e13$export$8e5a8e09b19b20a8 = 'isMoreActionsTourVisible';
const $3c94963df51c0e13$export$2e10b71f921ae144 = 'isMoreActionsHintVisible';
const $3c94963df51c0e13$export$82fe49566957c443 = 'landOnPath';
const $3c94963df51c0e13$export$49ac0bbeb4be0a06 = {
    ONBOARDING_INTENT_EXPERIENCES_CLOSED: 'onboarding-intent-experiences:onboardingIntentExperienceClosed',
    ONBOARDING_EXPERIENCE_ELIGIBLE: 'onboarding-intent-experience:isOnboardingExperienceEligibleUser',
    ONBOARDING_INTENT_EXPERIENCES_LAND_NEW_HOME_VIEWED_AT: 'onboarding-intent-experiences:onboardingIntentExperienceLandViewedAt',
    ONBOARDING_INTENT_EXPERIENCES_LAND_NEW_HOME_CLOSED: 'onboarding-intent-experiences:onboardingIntentExperienceLandClosed'
};
const $3c94963df51c0e13$export$6167e5b70dfd11d9 = {
    MODAL_SEEN: 'onboarding-reverse-trial:isModalSeen'
};
const $3c94963df51c0e13$export$49c044e5e3ccc2af = {
    EXPERIMENT_ELIGIBLE: 'templates-collection:isTaggedForTemplatesCollectionExperiment',
    EXPERIMENT_DISMISSED: 'templates-collection:isTemplatesSectionDismissed'
};
const $3c94963df51c0e13$export$dcbccfe8799c3c7b = {
    IS_DISMISSED: 'space-getting-started-tour:tourIsDismissed'
};
const $3c94963df51c0e13$export$305c55ea55928edf = {
    HAS_INVITE_CAPABILITIES: 'persistent-invite:hasInviteCapabilities'
};
const $3c94963df51c0e13$export$8b7e53c326da02ac = 'improvedGetStartedPath';
const $3c94963df51c0e13$export$cfc1794f56ac0d83 = 'improvedGetStartedWhiteboardPath';
const $3c94963df51c0e13$export$39a89660e80fa1a = 'isRedactionsTourVisible';
const $3c94963df51c0e13$export$b99b309b286adebc = 'nav4:isNav4GlobalSpotlightDismissed';
const $3c94963df51c0e13$export$20b0548cf5859d6 = 'nav4:isNav4SpaceTourDismissed';
const $3c94963df51c0e13$export$bcc4454330a6e241 = 'isContentWrapperLabelsTourDismissed';
const $3c94963df51c0e13$export$7ed75560092630f6 = {
    IS_SPOTLIGHT_DISMISS: 'whats-new-in-confluence:isWhatsNewInConfluneceSpotlightDismissed',
    PULSE_SEEN_AT: 'whats-new-in-confluence:whatsNewInConfluencePulseSeenAt'
};
const $3c94963df51c0e13$export$cba7fd986c721ece = {
    HAS_DISMISSED_MODAL: 'modernize-confluence-ipm-modal:hasDismissedModernizeConfluenceIpmModal',
    HAS_DISMISSED_BANNER: 'modernize-confluence-ipm-modal:hasDismissedModernizeConfluenceBanner'
};
const $3c94963df51c0e13$export$d1ec748fb682ca97 = {
    NTH_USER_SELECTED_CONTENT_TYPE: 'nth-user-setup:nthUserSelectedContentType',
    NTH_USER_CONTENT_TYPE_SPOTLIGHT_SEEN: 'nth-user-setup:nthUserContentTypeSpotlightSeen',
    NTH_USER_CONTENT_TYPE_POPULAR_CONTENT_FOUND: 'nth-user-setup:nthUserContentTypePopularContentFound',
    NTH_USER_CONTENT_TYPE_LANDING_CONTENT_ID: 'nth-user-setup:nthUserContentTypeLandingContentId'
};
const $3c94963df51c0e13$export$1a3a43cef0acd011 = {
    PROMPT_DISMISSED: 'prompt-whiteboard-competitor-link:isPromptDismissed'
};
const $3c94963df51c0e13$export$bfeb2da96277b623 = {
    INTRO_WORKFLOW: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$31c8494ea74d2536}`,
    LEGACY_ONBOARDING_STATE: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$532485ca1547f1aa}`,
    IS_FOUNDING_ADMIN: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$d3276a0d758ffd2b}`,
    IS_SAMPLE_CONTENT_V2_SPOTLIGHT_VISIBLE: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$756b1a5a6b2488c3}`,
    LAND_ON_PATH: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$82fe49566957c443}`,
    TEAM_SPACE_CREATED: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$6315bee451a9fcc6}`,
    IS_MORE_ACTIONS_TOUR_VISIBLE: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$8e5a8e09b19b20a8}`,
    IS_MORE_ACTIONS_HINT_VISIBLE: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$2e10b71f921ae144}`,
    IMPROVED_GET_STARTED_PATH: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$8b7e53c326da02ac}`,
    IMPROVED_GET_STARTED_WHITEBOARD_PATH: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$cfc1794f56ac0d83}`,
    IS_REDACTIONS_TOUR_VISIBLE: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$39a89660e80fa1a}`,
    IS_CONTENT_WRAPPER_LABELS_TOUR_DISMISSED: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$bcc4454330a6e241}`
};
const $3c94963df51c0e13$export$1660a2d7c2fff354 = '__complete__';
const { LEGACY_ONBOARDING_STATE: $3c94963df51c0e13$export$66aa87593037fd4a } = $3c94963df51c0e13$export$bfeb2da96277b623;

});

parcelRegister("N1nBh", function(module, exports) {

$parcel$export(module.exports, "ActionTiming", () => $4fef2d066feab689$export$6a673e74e98cdf55);
$parcel$export(module.exports, "usePerformanceAction", () => $4fef2d066feab689$export$454639fd58f598bd);

var $gwFzn = parcelRequire("gwFzn");
var $4fef2d066feab689$export$6a673e74e98cdf55 = /*#__PURE__*/ function(ActionTiming) {
    /**
	 * This will perform the given action at a scheduled time after the
	 * component has painted.
	 *
	 * This is the default behavior.
	 */ ActionTiming["DEFAULT"] = "DEFAULT";
    /**
	 * This will perform the given action at the next animation frame (after the
	 * component has been painted).
	 */ ActionTiming["PAINT"] = "PAINT";
    /**
	 * This will perform the given action at the moment its render function
	 * fires.
	 *
	 * NOTE: This is called _within_ the render body, making it unpure. The
	 * component is memoized, so it will fire this only once for a given set
	 * of props. Be careful when using this, since it is unsafe.
	 */ ActionTiming["RENDER_BODY"] = "RENDER_BODY";
    return ActionTiming;
}({});
const $4fef2d066feab689$export$454639fd58f598bd = (action, timing = "DEFAULT")=>{
    // The "RENDER_BODY" mark timing
    if (timing === "RENDER_BODY") action();
    // The "PAINT" mark timing
    (0, $gwFzn.useLayoutEffect)(()=>{
        if (timing === "PAINT") {
            const frameRequest = requestAnimationFrame(()=>{
                action();
            });
            return ()=>{
                cancelAnimationFrame(frameRequest);
            };
        }
    }, [
        action,
        timing
    ]);
    // The "DEFAULT" mark timing
    (0, $gwFzn.useEffect)(()=>{
        if (timing === "DEFAULT") action();
    }, [
        action,
        timing
    ]);
};

});

parcelRegister("eEhUN", function(module, exports) {

var $2jjxD = parcelRequire("2jjxD");

var $ziEnt = parcelRequire("ziEnt");
/** Error message constants. */ var $aaa2b2acc3d694b1$var$FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */ function $aaa2b2acc3d694b1$var$throttle(func, wait, options) {
    var leading = true, trailing = true;
    if (typeof func != 'function') throw new TypeError($aaa2b2acc3d694b1$var$FUNC_ERROR_TEXT);
    if ($ziEnt(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
    }
    return $2jjxD(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
    });
}
module.exports = $aaa2b2acc3d694b1$var$throttle;

});

parcelRegister("lsxnT", function(module, exports) {

$parcel$export(module.exports, "useChoreographerAssets", () => $be0f158b0b06806d$export$20bf42c8a29d776a);

var $gwFzn = parcelRequire("gwFzn");

var $cryCi = parcelRequire("cryCi");
const $be0f158b0b06806d$export$20bf42c8a29d776a = ()=>{
    const ctx = (0, $gwFzn.useContext)((0, $cryCi.Context));
    if (!ctx) throw new Error('ChoreographerAssetsContext not found, did you include the correct Context provider?');
    return ctx;
};

});

parcelRegister("gfIPU", function(module, exports) {

$parcel$export(module.exports, "ExperienceFailure", () => $5675860ef242c9e4$export$eed1d73ebdd8c7ab);

var $gwFzn = parcelRequire("gwFzn");

var $1kHsc = parcelRequire("1kHsc");
function $5675860ef242c9e4$export$eed1d73ebdd8c7ab({ name: name, error: error, attributes: attributes }) {
    const experienceTracker = (0, $gwFzn.useContext)((0, $1kHsc.ExperienceTrackerContext));
    (0, $gwFzn.useEffect)(()=>experienceTracker.fail({
            name: name,
            error: error,
            attributes: attributes
        }), [
        experienceTracker,
        name,
        error,
        attributes
    ]);
    return null;
}

});

parcelRegister("9NwnH", function(module, exports) {

$parcel$export(module.exports, "rebaseSteps", () => $c4b7da7a59ba31a1$export$bced9e015fcf3afa);
$parcel$export(module.exports, "collab", () => $c4b7da7a59ba31a1$export$995d9de96d1b2e26);
$parcel$export(module.exports, "getDocBeforeUnconfirmedSteps", () => $c4b7da7a59ba31a1$export$5af1c9a2797f6d8e);
$parcel$export(module.exports, "syncFromAnotherSource", () => $c4b7da7a59ba31a1$export$852bd88de4de2d35);
$parcel$export(module.exports, "receiveTransaction", () => $c4b7da7a59ba31a1$export$7581d8ca0d559ec6);
$parcel$export(module.exports, "sendableSteps", () => $c4b7da7a59ba31a1$export$4da2109e7644e6c2);
$parcel$export(module.exports, "getCollabState", () => $c4b7da7a59ba31a1$export$971539697c176258);

var $9HkI0 = parcelRequire("9HkI0");

var $7T7aA = parcelRequire("7T7aA");

var $iu6m9 = parcelRequire("iu6m9");

var $5jGZY = parcelRequire("5jGZY");
class $c4b7da7a59ba31a1$export$c6d36d70c8e9d8cd {
    constructor(step, inverted, origin){
        this.step = step;
        this.inverted = inverted;
        this.origin = origin;
    }
}
function $c4b7da7a59ba31a1$export$bced9e015fcf3afa(steps, over, transform) {
    for(let i = steps.length - 1; i >= 0; i--)transform.step(steps[i].inverted);
    for(let i = 0; i < over.length; i++)transform.step(over[i]);
    const result = [];
    for(let i = 0, mapFrom = steps.length; i < steps.length; i++){
        const mapped = steps[i].step.map(transform.mapping.slice(mapFrom));
        const movedStep = (0, $iu6m9.editorExperiment)('platform_editor_offline_editing_web', true) ? (0, $5jGZY.mapStep)(steps, transform, i, mapped) : undefined;
        mapFrom--;
        if (mapped && !transform.maybeStep(mapped).failed) {
            // Open ticket for setMirror https://github.com/ProseMirror/prosemirror/issues/869
            // @ts-expect-error
            transform.mapping.setMirror(mapFrom, transform.steps.length - 1);
            result.push(new $c4b7da7a59ba31a1$export$c6d36d70c8e9d8cd(mapped, mapped.invert(transform.docs[transform.docs.length - 1]), steps[i].origin));
        }
        // If the step is a "move" step - apply the additional step
        if ((0, $iu6m9.editorExperiment)('platform_editor_offline_editing_web', true)) {
            if (movedStep && !transform.maybeStep(movedStep).failed) result.push(new $c4b7da7a59ba31a1$export$c6d36d70c8e9d8cd(movedStep, movedStep.invert(transform.docs[transform.docs.length - 1]), transform));
        }
    }
    return result;
}
// This state field accumulates changes that have to be sent to the
// central authority in the collaborating group and makes it possible
// to integrate changes made by peers into our local document. It is
// defined by the plugin, and will be available as the `collab` field
// in the resulting editor state.
class $c4b7da7a59ba31a1$var$CollabState {
    constructor(// The version number of the last update received from the central
    // authority. Starts at 0 or the value of the `version` property
    // in the option object, for the editor's value when the option
    // was enabled.
    version, // The local steps that havent been successfully sent to the
    // server yet.
    unconfirmed){
        this.version = version;
        this.unconfirmed = unconfirmed;
    }
}
function $c4b7da7a59ba31a1$var$unconfirmedFrom(transform) {
    const result = [];
    for(let i = 0; i < transform.steps.length; i++)// Filter out the analytics steps, they don't need to be sent to the collab service
    // Commented out because it broke undo behaviour
    // TODO: ED-26957 - Figure out how it broke undo
    // if (transform.steps[i] instanceof AnalyticsStep) {
    //   continue;
    // }
    result.push(new $c4b7da7a59ba31a1$export$c6d36d70c8e9d8cd(transform.steps[i], transform.steps[i].invert(transform.docs[i]), transform));
    return result;
}
const $c4b7da7a59ba31a1$var$collabKey = new (0, $7T7aA.PluginKey)('collab');
function $c4b7da7a59ba31a1$export$995d9de96d1b2e26(config = {}) {
    const conf = {
        version: config.version || 0,
        clientID: // eslint-disable-next-line eqeqeq
        // generate a temporary id as clientId when it is null or undefined
        // prefix temp-pc- indicates prosemirror-collab
        config.clientID == null || !config.clientID ? `temp-pc-${(0, $9HkI0.v4)()}` : config.clientID
    };
    const transformUnconfirmed = config.transformUnconfirmed ?? ((steps)=>steps);
    return new (0, $7T7aA.Plugin)({
        key: $c4b7da7a59ba31a1$var$collabKey,
        state: {
            init: ()=>new $c4b7da7a59ba31a1$var$CollabState(conf.version, []),
            apply (tr, collab) {
                const newState = tr.getMeta($c4b7da7a59ba31a1$var$collabKey);
                if (newState) {
                    if ((0, $iu6m9.editorExperiment)('platform_editor_offline_editing_web', true)) return new $c4b7da7a59ba31a1$var$CollabState(newState.version, transformUnconfirmed(newState.unconfirmed));
                    else return newState;
                }
                if (tr.docChanged) return new $c4b7da7a59ba31a1$var$CollabState(collab.version, transformUnconfirmed(collab.unconfirmed.concat($c4b7da7a59ba31a1$var$unconfirmedFrom(tr))));
                return collab;
            }
        },
        config: conf,
        // This is used to notify the history plugin to not merge steps,
        // so that the history can be rebased.
        historyPreserveItems: true
    });
}
function $c4b7da7a59ba31a1$export$5af1c9a2797f6d8e(state) {
    const tr = state.tr;
    const { version: version, unconfirmed: unconfirmed } = $c4b7da7a59ba31a1$var$collabKey.getState(state) ?? {};
    if (version === undefined || !unconfirmed) return tr.doc;
    // undo unconfirmed steps
    for(let i = unconfirmed.length - 1; i >= 0; i--)tr.step(unconfirmed[i].inverted);
    return tr.doc;
}
function $c4b7da7a59ba31a1$export$852bd88de4de2d35(state, version, // eslint-disable-next-line @typescript-eslint/no-explicit-any
docJSON, unconfirmedSteps) {
    const tr = state.tr;
    const doc = state.schema.nodeFromJSON(docJSON);
    const { from: from, to: to } = tr.selection;
    tr.replaceWith(0, state.doc.content.size, doc);
    tr.setSelection((0, $7T7aA.TextSelection).create(tr.doc, Math.min(tr.mapping.map(from), tr.doc.nodeSize), Math.min(tr.mapping.map(to), tr.doc.nodeSize)));
    // apply new unconfirmed steps to doc
    for(let i = 0; i < unconfirmedSteps.length; i++)tr.step(unconfirmedSteps[i]);
    const offset = 1; // offset by 1 to account for the initial replace step
    const newUnconfirmed = tr.steps.slice(offset).map((step, i)=>{
        const index = i + offset;
        const doc = tr.docs[index];
        return new $c4b7da7a59ba31a1$export$c6d36d70c8e9d8cd(step, step.invert(doc), tr);
    });
    return tr.setMeta('addToHistory', false).setMeta($c4b7da7a59ba31a1$var$collabKey, new $c4b7da7a59ba31a1$var$CollabState(version, newUnconfirmed));
}
function $c4b7da7a59ba31a1$export$7581d8ca0d559ec6(state, steps, clientIDs, options = {}) {
    // Pushes a set of steps (received from the central authority) into
    // the editor state (which should have the collab plugin enabled).
    // Will recognize its own changes, and confirm unconfirmed steps as
    // appropriate. Remaining unconfirmed steps will be rebased over
    // remote steps.
    const collabState = $c4b7da7a59ba31a1$var$collabKey.getState(state);
    const version = (collabState?.version || 0) + steps.length;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion,  @typescript-eslint/no-explicit-any
    const ourID = $c4b7da7a59ba31a1$var$collabKey.get(state).spec.config.clientID;
    // Find out which prefix of the steps originated with us
    let ours = 0;
    // eslint-disable-next-line eqeqeq
    while(ours < clientIDs.length && clientIDs[ours] == ourID)++ours;
    let unconfirmed = collabState?.unconfirmed.slice(ours) || [];
    steps = ours ? steps.slice(ours) : steps;
    // If all steps originated with us, we're done.
    if (!steps.length) return state.tr.setMeta($c4b7da7a59ba31a1$var$collabKey, new $c4b7da7a59ba31a1$var$CollabState(version, unconfirmed));
    const nUnconfirmed = unconfirmed.length;
    const tr = state.tr;
    if (nUnconfirmed) unconfirmed = $c4b7da7a59ba31a1$export$bced9e015fcf3afa(unconfirmed, steps, tr);
    else {
        for(let i = 0; i < steps.length; i++)tr.step(steps[i]);
        unconfirmed = [];
    }
    const newCollabState = new $c4b7da7a59ba31a1$var$CollabState(version, unconfirmed);
    if (options && options.mapSelectionBackward && state.selection instanceof (0, $7T7aA.TextSelection)) {
        tr.setSelection(new (0, $7T7aA.TextSelection)(tr.doc.resolve(tr.mapping.map(state.selection.anchor, -1)), tr.doc.resolve(tr.mapping.map(state.selection.head, -1))));
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        tr.updated &= -2;
    }
    return tr.setMeta('rebased', nUnconfirmed).setMeta('rebasedData', {
        unconfirmedSteps: collabState?.unconfirmed.slice(ours) || [],
        remoteSteps: steps,
        stepsAfterRebase: unconfirmed,
        versionBefore: version
    }).setMeta('addToHistory', false).setMeta($c4b7da7a59ba31a1$var$collabKey, newCollabState);
}
function $c4b7da7a59ba31a1$export$4da2109e7644e6c2(state) {
    const collabState = $c4b7da7a59ba31a1$var$collabKey.getState(state);
    if (!collabState) return null;
    // eslint-disable-next-line eqeqeq
    if (collabState.unconfirmed.length == 0) return null;
    return {
        version: collabState.version,
        steps: collabState.unconfirmed.map((s)=>s.step),
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion, @typescript-eslint/no-explicit-any
        clientID: $c4b7da7a59ba31a1$var$collabKey.get(state).spec.config.clientID,
        get origins () {
            return(// Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            this._origins || (// Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            this._origins = collabState?.unconfirmed.map((s)=>s.origin)));
        }
    };
}
function $c4b7da7a59ba31a1$export$971539697c176258(state) {
    return $c4b7da7a59ba31a1$var$collabKey.getState(state);
}

});
parcelRegister("5jGZY", function(module, exports) {

$parcel$export(module.exports, "mapStep", () => $33dcd085767efb3e$export$798cdecdcbbf9755);

var $lTYwY = parcelRequire("lTYwY");

var $kviC1 = parcelRequire("kviC1");

var $4FvAQ = parcelRequire("4FvAQ");
// Iterate from the specified starting index down to 0
const $33dcd085767efb3e$var$findPreviousStepInverseIndex = (steps, startIndex = steps.length - 1)=>{
    for(let i = startIndex; i >= 0; i--){
        if (!(steps[i] instanceof (0, $lTYwY.AnalyticsStep))) return i;
    }
};
const $33dcd085767efb3e$export$798cdecdcbbf9755 = (steps, transform, index, mapped)=>{
    if (index < 1) return undefined;
    const previousRebaseableStepIndex = $33dcd085767efb3e$var$findPreviousStepInverseIndex(steps.map((s)=>s.step), index - 1);
    // This checks the local steps are a "move" sequence
    if (previousRebaseableStepIndex !== undefined && $33dcd085767efb3e$export$17bbdbb89ac2acbd(steps[previousRebaseableStepIndex], steps[index].step)) {
        const previousStepInverseIndex = $33dcd085767efb3e$var$findPreviousStepInverseIndex(transform.steps);
        // Creates a new step based on the "current" steps (partially through the rebase)
        if (previousStepInverseIndex !== undefined) return $33dcd085767efb3e$export$ad07b298545ed98d(mapped, transform.steps[previousStepInverseIndex], transform, previousStepInverseIndex);
    }
};
// Only consider ReplaceStep (ReplaceAroundStep do not occur for moves)
const $33dcd085767efb3e$var$isReplaceTypeStep = (step)=>step instanceof (0, $4FvAQ.ReplaceStep);
const $33dcd085767efb3e$export$17bbdbb89ac2acbd = (previousRebaseableStep, currentStep)=>{
    if (// The both steps are replace
    $33dcd085767efb3e$var$isReplaceTypeStep(previousRebaseableStep.step) && $33dcd085767efb3e$var$isReplaceTypeStep(currentStep) && // The current step is a deletion
    previousRebaseableStep.step.slice.size === 0 && // The following step is an insertion with the same length that was deleted by the current step
    Math.abs(previousRebaseableStep.step.to - previousRebaseableStep.step.from) === currentStep.slice.size) {
        // Ensure we're getting the doc before our step changes so we can compare node contents
        const originStepIndex = previousRebaseableStep.origin.steps.findIndex((s)=>s === previousRebaseableStep.step);
        const originalDoc = previousRebaseableStep.origin.docs[originStepIndex];
        const currentSlice = originalDoc.slice(previousRebaseableStep.step.from, previousRebaseableStep.step.to);
        // The content from the deleted + inserted slice is exactly the same (cut + paste or drag + drop)
        if (currentSlice.eq(currentStep.slice)) return true;
    }
    return false;
};
const $33dcd085767efb3e$export$ad07b298545ed98d = (mapped, previousStep, transform, previousStepIndex)=>{
    if (!$33dcd085767efb3e$var$isReplaceTypeStep(previousStep) || mapped && !$33dcd085767efb3e$var$isReplaceTypeStep(mapped) || !mapped) return undefined;
    const newSlice = transform.docs[previousStepIndex].slice(previousStep?.from, previousStep?.to);
    const diff = $33dcd085767efb3e$var$getDiffRange(mapped.slice.content, newSlice.content);
    if (diff === undefined) return undefined;
    const start = mapped.from + diff.start;
    const offset = newSlice.content.size - mapped.slice.content.size === 0 ? diff.end - diff.start : 0;
    // If the new slice is smaller then we're doing a deletion of content - this needs
    // to be a replace step with empty content to delete content
    if (newSlice.content.size - mapped.slice.content.size < 0) return new (0, $4FvAQ.ReplaceStep)(start, start + mapped.slice.content.size - newSlice.content.size, (0, $kviC1.Slice).empty);
    // Replace the diff range with the latest content in the document (at the old position)
    return new (0, $4FvAQ.ReplaceStep)(start, start + offset, transform.docs[previousStepIndex].slice(previousStep?.from + diff.start, previousStep?.from + diff.end));
};
/**
 * Get start and end diff position values for two fragments (old, new).
 * @param {Fragment} before - content that is planned to move
 * @param {Fragment} after - content that was in paragraph being deleted (updated content)
 * @returns {object} - { start, end }
 */ function $33dcd085767efb3e$var$getDiffRange(before, after) {
    // https://prosemirror.net/docs/ref/#model.Fragment.findDiffStart
    const start = before.findDiffStart(after);
    // Important: diffEnd value is {a,b} object since end pos will differ.
    // https://prosemirror.net/docs/ref/#model.Fragment.findDiffEnd
    const diffEnd = before.findDiffEnd(after);
    if (start === null || diffEnd === null) return undefined;
    // WARNING: diffEnd may be lower than diffStart.
    // If so, add overlap to get correct range.
    // https://discuss.prosemirror.net/t/overlap-handling-of-finddiffstart-and-finddiffend/2856
    const overlap = start - Math.min(diffEnd.a, diffEnd.b);
    let end = diffEnd.b;
    if (overlap > 0) end += overlap;
    return {
        start: start,
        end: end
    };
}

});


parcelRegister("ao6k0", function(module, exports) {

$parcel$export(module.exports, "PageLoadEnd", () => $3ef4c99d4b0f9884$export$570dec5b65c6715b);

var $gwFzn = parcelRequire("gwFzn");

var $ipPpS = parcelRequire("ipPpS");

var $kmyZQ = parcelRequire("kmyZQ");

var $78QFu = parcelRequire("78QFu");

var $7sK8i = parcelRequire("7sK8i");

var $dIouf = parcelRequire("dIouf");

var $5ZqQS = parcelRequire("5ZqQS");

var $dtDUi = parcelRequire("dtDUi");

var $6VdZc = parcelRequire("6VdZc");
var $7fw2E = parcelRequire("7fw2E");
const $3ef4c99d4b0f9884$var$PageLoadEndImpl = /*#__PURE__*/ (0, $gwFzn.memo)(({ metric: metric, customData: customData = {}, stopTime: stopTime, onComplete: onComplete })=>{
    (0, $gwFzn.useEffect)(()=>{
        const stopArguments = {
            stopTime: typeof stopTime === 'number' ? stopTime : undefined,
            customData: {
                ...customData,
                previousRoute: (0, $6VdZc.browserMetricsState).previousRoute,
                pageLoadInfo: (0, $78QFu.getUniquePageLoadId)()
            }
        };
        metric.stop(stopArguments);
        (0, $7fw2E.markBrowserMetricEnd)(metric);
        (0, $7sK8i.resumeLowPriorityEvents)();
        // trigger onComplete regardless of FF - PageLoadEnd can stop the progress bar temporarily,
        // as ProgressBarContainer returns early if the progress bar has already been stopped.
        onComplete();
    // Not adding exhaustive dependencies because we want this to fire only once,
    // despite any changes to `customData` or `stopTime`
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        onComplete,
        metric
    ]);
    return null;
});
const $3ef4c99d4b0f9884$var$PageLoadEndComponent = /*#__PURE__*/ (0, $gwFzn.memo)(({ metric: metric, customData: customData, stopTime: stopTime })=>{
    if (window?.__SSR_RENDERED__ && Boolean(window.__HYDRATION_FAILED__)) {
        const errorWithRoute = (0, $dtDUi.getHydrationErrorWithRoute)(window.location.toString());
        (0, $5ZqQS.getMonitoringClient)().submitError(errorWithRoute, {
            attribution: 'hydration'
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ipPpS.Subscribe), {
        to: [
            (0, $kmyZQ.ProgressBarContainer)
        ]
    }, (progressBar)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($3ef4c99d4b0f9884$var$PageLoadEndImpl, {
            metric: metric,
            customData: customData,
            stopTime: stopTime,
            onComplete: progressBar.finish
        }));
});
const $3ef4c99d4b0f9884$export$570dec5b65c6715b = (0, $dIouf.withTransparentErrorBoundary)({
    attribution: (0, $dIouf.Attribution).BACKBONE
})($3ef4c99d4b0f9884$var$PageLoadEndComponent);

});

parcelRegister("3Klda", function(module, exports) {

$parcel$export(module.exports, "ContentScreenBackgroundLayer", () => $2ba61f17a8768eba$export$e0e5b47f08900b58);

var $fppBw = parcelRequire("fppBw");

var $gwFzn = parcelRequire("gwFzn");
const $2ba61f17a8768eba$var$screenLayerStyles = {
    display: 'block',
    position: 'absolute',
    width: '100%',
    top: 0,
    left: 0,
    height: 250
};
class $2ba61f17a8768eba$export$e0e5b47f08900b58 extends (0, $gwFzn.Component) {
    render() {
        const { lookAndFeel: lookAndFeel } = this.props;
        if (!lookAndFeel || !lookAndFeel.content) return null;
        const customScreenLayerStyles = lookAndFeel?.content?.screen?.layer || {};
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("div", {
            "data-testid": "content-screen-background-layer",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: {
                ...$2ba61f17a8768eba$var$screenLayerStyles,
                ...customScreenLayerStyles
            }
        });
    }
}
$2ba61f17a8768eba$export$e0e5b47f08900b58.propTypes = {
    lookAndFeel: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).object
};

});


//# sourceMappingURL=LivePageComponent.e118f86d.js.map
